import React, { useEffect, useMemo, useState } from "react";
import { StepUpSpinner } from "../../../Components/Loader";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  CircularProgress,
  Grid,
  Box,
  Button,
  Card,
  Typography,
  List,
  ListItem,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogActions,
  IconButton,
  Tooltip,
  Chip,
  Divider,
  Avatar,
} from "@mui/material";
import {
  useGetEmployeeScheduleDetailsByDateQuery,
  useGetPunchDashboardQuery,
  useGetTeamQuery,
  useGetUserInfoOnyQuery,
  useGetCheckAttananceStatusQuery,
  useGetEmpScheduleDetailsByDateDeleteRecordQuery,
  useGetOutOfLocationQuery,
} from "../../../Api/attoDeskApi";
import {
  IScheduleListDetails,
  ITeam,
  IUserAdmin,
  PunchDetails,
  historyPuncRecord,
} from "../../../Api/Interface/api.interface";
import { useNotifier } from "../../../Core/Notifier";
import useDebounce from "../../../Components/SearchDebonce/useDebounce";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useStyles } from "../../../theme/appStyles";
import EditSharpIcon from "@mui/icons-material/EditSharp";
import { Privileges } from "../../../Core/Enum/enum";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs, { Dayjs } from "dayjs";
import EmpImg from "../Component/EmpImg";
import AdminEdit from "../AdminEdit/index";
import useUser from "../../../Core/hook/useUser";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import CloseIcon from "@mui/icons-material/Close";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import NorthIcon from "@mui/icons-material/North";
import SouthIcon from "@mui/icons-material/South";
import Groups2OutlinedIcon from "@mui/icons-material/Groups2Outlined";
import CheckCircleOutlinedIcon from "@mui/icons-material/CheckCircleOutlined";
import AdminPunchInEdit from "../AdminEdit/editPunchInTime";
import AdminPunchOutEdit from "../AdminEdit/editPunchOutTime";
import jsPDF from "jspdf";
import "jspdf-autotable";
import * as XLSX from "xlsx";
import TableViewIcon from "@mui/icons-material/TableView";
import LocalPrintshopSharpIcon from "@mui/icons-material/LocalPrintshopSharp";
import { CiEdit } from "react-icons/ci";
import { toProperCase } from "../../../Components/Validation/toProperCase";
import { faLink } from "@fortawesome/free-solid-svg-icons";
import { faUser } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import useIsMobile from "../../../Core/hook/useIsMobile";
import { useSelector } from "react-redux";
import { RootState } from "../../../Store";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import AdminDeleteTimeSlote from "../AdminEdit/deleteTimeSchedule";
import DeleteOutlineSharpIcon from "@mui/icons-material/DeleteOutlineSharp";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import { styled, useTheme, Theme, CSSObject } from "@mui/material/styles";
import GroupIcon from "@mui/icons-material/Group";
import Badge from "@mui/material/Badge";
import QuestionMarkIcon from "@mui/icons-material/QuestionMark";

const formatTime = (time: string | undefined) => {
  if (!time) return "";
  const [hour, minute] = time.split(":").map(Number);
  const date = new Date();
  date.setHours(hour, minute);
  return new Intl.DateTimeFormat("en-CA", {
    hour: "numeric",
    minute: "numeric",
    hour12: true,
  }).format(date);
};

const Index = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobileRes = useIsMobile();
  const { companyLogo, logowidthPrint, companyName } = useSelector(
    (state: RootState) => state.company
  );
  const { showErrorMessage, showMessage } = useNotifier();
  const [searchQuery, setSearchQuery] = useState("");
  const [currentSearchQuery, setCurrentSearchQuery] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(100000);
  const debouncedSearchQuery = useDebounce(searchQuery, 300);
  const { userHasRight } = useUser();
  const [searchParams] = useSearchParams();
  const selectedDateAttandanceList = searchParams.get("date");

  const [selectedCoursing, setSelectedCoursing] =
    useState<IScheduleListDetails | null>(null);
  const [openDialog, setOpenDialog] = useState(false);

  const [selectedAdminEdit, setSelectedAdminEdit] =
    useState<IScheduleListDetails | null>(null);
  const [openDialogAdminEdit, setOpenDialogAdminEdit] = useState(false);
  const [selectedAdminEditStatus, setSelectedAdminEditStatus] = useState<
    String | undefined
  >("");
  const [selectedAdminDeleteId, setSelectedAdminDeleteId] = useState<
    String | undefined
  >("");
  const [selectedAdminDeleteMessage, setSelectedAdminDeleteMessage] = useState<
    String | undefined
  >("");
  const [openDialogAdminDelete, setOpenDialogAdminDelete] = useState(false);
  const [selectedAdminDelete, setSelectedAdminDelete] =
    useState<IScheduleListDetails | null>(null);

  const [selectedAdminEditPunchIn, setSelectedAdminEditPunchIn] =
    useState<PunchDetails | null>(null);
  const [openDialogAdminEditPunchIn, setOpenDialogAdminEditPunchIn] =
    useState(false);

  const [selectedAdminEditPunchOut, setSelectedAdminEditPunchOut] =
    useState<PunchDetails | null>(null);
  const [openDialogAdminEditPunchOut, setOpenDialogAdminEditPunchOut] =
    useState(false);

  const [selectedImg, setSelectedImg] = useState<IScheduleListDetails | null>(
    null
  );
  const [openDialogImg, setOpenDialogImg] = useState(false);
  const [selectedIsBooked, setSelectedProductIsBooked] = useState<string>("");
  const [paymentMonthYear, setPaymentMonthYear] = useState<Dayjs>(dayjs());
  const [selectedDate, setSelectedDate] = React.useState<Dayjs | null>(dayjs());

  const [open, setOpen] = useState(false);

  useEffect(() => {
    const selectedDateAttandanceList = searchParams.get("date");
    if (selectedDateAttandanceList) {
      const parsedDate = dayjs(selectedDateAttandanceList, "YYYY-MM-DD", true); // Parse the date with strict mode
      if (parsedDate.isValid()) {
        setSelectedDate(parsedDate);
        setPaymentMonthYear(dayjs(parsedDate));
      }
    }
  }, [searchParams]);

  const {
    data: attanceData,
    isLoading: attanceIsLoaing,
    isError: attanceIsError,
    refetch: attananceRefetch,
  } = useGetCheckAttananceStatusQuery({ id: 1 }, { pollingInterval: 10000 });

  const { data, isLoading, isError, refetch } =
    useGetEmployeeScheduleDetailsByDateQuery({
      date: paymentMonthYear.format("YYYY-MM-DD"),
    });

  const {
    data: deleteRecordData,
    isLoading: deleteRecordIsLoadig,
    isError: deleteRecordIsError,
    refetch: deleteRecordRefetch,
  } = useGetEmpScheduleDetailsByDateDeleteRecordQuery({
    date: paymentMonthYear.format("YYYY-MM-DD"),
  });

  const {
    data: outOfLocationData,
    isLoading: outOfLocationIsLoadig,
    isError: outOfLocationIsError,
    refetch: outOfLocationRefetch,
  } = useGetOutOfLocationQuery({
    date: paymentMonthYear.format("YYYY-MM-DD"),
  });

  const handleIsBooked = (event: React.ChangeEvent<HTMLInputElement>) => {
    const selectedValue = event.target.value;
    setPaymentMonthYear(dayjs(selectedValue));
  };

  const { data: tenantData, isLoading: tenantIsLoading } = useGetTeamQuery({
    searchText: "",
    id: "",
  });

  const {
    data: dashboardData,
    isLoading: dashboardIsLoading,
    isError: dashboardIsError,
    refetch: dashboardRefetch,
  } = useGetPunchDashboardQuery();

  const { data: userData, isLoading: userIsLoading } = useGetUserInfoOnyQuery({
    searchText: "",
  });

  React.useEffect(() => {
    if (attanceData?.active_status == "1") {
      refetch();
      dashboardRefetch();
      deleteRecordRefetch();
      outOfLocationRefetch();
    }
  }, [attanceData, refetch, dashboardRefetch, deleteRecordRefetch, outOfLocationRefetch]);

  const teamList = useMemo(() => {
    return tenantData?.data as ITeam[];
  }, [tenantData?.data]);

  const userList = useMemo(() => {
    return userData?.data as IUserAdmin[];
  }, [userData?.data]);

  const userMap = useMemo(() => {
    const map = new Map();
    userList?.forEach((user) => {
      map.set(user.id, `${user.user_role_name}`);
    });
    return map;
  }, [userList]);

  const teamMap = useMemo(() => {
    const map = new Map<number, { name: string; image: string }>(); // Map to hold id as key and an object with name and image as value
    teamList?.forEach((teamMember) => {
      const fullName = `${toProperCase(
        teamMember.teamFirstName || ""
      )} ${toProperCase(teamMember?.teamLastName || "")}`;
      map.set(teamMember.id, { name: fullName, image: teamMember.teamImg });
    });
    return map;
  }, [teamList]);

  useEffect(() => {
    if (debouncedSearchQuery.length >= 4 || debouncedSearchQuery === "") {
      setCurrentSearchQuery(debouncedSearchQuery);
      refetch();
    }
  }, [debouncedSearchQuery]);

  const handleOpenDialogAdminEdit = (
    coursing: IScheduleListDetails,
    status: string
  ) => {
    setSelectedAdminEditStatus(status);
    setSelectedAdminEdit(coursing);
    setOpenDialogAdminEdit(true);
  };

  const handleOpenDialogAdminDelete = (
    id: string,
    name: string,
    coursing: IScheduleListDetails
  ) => {
    setSelectedAdminDeleteId(id);
    setSelectedAdminDeleteMessage(name);
    setOpenDialogAdminDelete(true);
    setSelectedAdminDelete(coursing);
  };

  const handleCloseDialogAdminDelete = () => {
    setSelectedAdminDeleteId(undefined);
    setSelectedAdminDeleteMessage(undefined);
    setOpenDialogAdminDelete(false);
    setSelectedAdminDelete(null);
  };

  const handleOpenDialogAdminEditPunchIn = (coursing: PunchDetails) => {
    setSelectedAdminEditPunchIn(coursing);
    setOpenDialogAdminEditPunchIn(true);
  };

  const handleOpenDialogAdminEditPunchOut = (coursing: PunchDetails) => {
    setSelectedAdminEditPunchOut(coursing);
    setOpenDialogAdminEditPunchOut(true);
  };

  const handleCloseDialogAdminEdit = () => {
    setSelectedAdminEdit(null);
    setOpenDialogAdminEdit(false);
    setSelectedAdminEditStatus(undefined);
  };

  const handleCloseDialogAdminEditPunchIn = () => {
    setSelectedAdminEditPunchIn(null);
    setOpenDialogAdminEditPunchIn(false);
  };

  const handleCloseDialogAdminEditPunchOut = () => {
    setSelectedAdminEditPunchOut(null);
    setOpenDialogAdminEditPunchOut(false);
  };

  const handleCloseDialog = () => {
    setSelectedCoursing(null);
    setOpenDialog(false);
  };
  const handleCloseDialogImg = () => {
    setSelectedImg(null);
    setOpenDialogImg(false);
  };

  const handleDateChange = (newValue: Dayjs | null) => {
    setSelectedDate(newValue);

    if (newValue) {
      const mockEvent = {
        target: {
          value: newValue.format("YYYY-MM-DD"),
        },
      } as React.ChangeEvent<HTMLInputElement>;

      handleIsBooked(mockEvent);
    }
  };

  const handleCloseDialogGenerate = () => {
    setOpen(false);
  };

  const handleConfirm = () => {
    setOpen(false);
    navigate("/payroll/generate");
  };

  const goToPreviousDay = () => {
    const prevDay =
      selectedDate?.subtract(1, "day") || dayjs().subtract(1, "day");
    handleDateChange(prevDay);
  };

  const goToNextDay = () => {
    const nextDay = selectedDate?.add(1, "day") || dayjs().add(1, "day");
    handleDateChange(nextDay);
  };

  const coursings: IScheduleListDetails[] = Array.isArray(data?.data)
    ? (data?.data as IScheduleListDetails[])
    : [];

  const deleteRecords: IScheduleListDetails[] = Array.isArray(
    deleteRecordData?.data
  )
    ? (deleteRecordData?.data as IScheduleListDetails[])
    : [];

  const outOfLocationRecords: historyPuncRecord[] = Array.isArray(
    outOfLocationData?.data
  )
    ? (outOfLocationData?.data as historyPuncRecord[])
    : [];

  const handleAddProductClick = () => {
    navigate(
      `/attendance/create?date=${paymentMonthYear.format("YYYY-MM-DD")}`
    );
  };

  const handleExportToExcel = () => {
    // const tableData = coursings.map((row, index) => ({
    //   "#": index + 1,
    //   Name: teamMap.get(row.empid)?.name || "",
    //   Schedule: `${formatTime(row.schedule?.startTime) || " "} - ${
    //     formatTime(row.schedule?.endTime) || " "
    //   }`,
    //   "Clocked Hours": row.workStartTime?.actual_punched_time
    //     ? `${formatTime(row.workStartTime.actual_punched_time)} - ${
    //         row.finishWorkTime?.actual_punched_time
    //           ? formatTime(row.finishWorkTime.actual_punched_time)
    //           : "Pending"
    //       }`
    //     : " ",
    //   "Punch In": formatTime(row.workStartTime?.punched_time) || "Pending",
    //   // "Punch Out": formatTime(row.finishWorkTime?.punched_time) || "Pending",
    //   "Punch Out": row.finishWorkTime?.punched_time
    //     ? row.workStartTime?.punched_date !== row.finishWorkTime.punched_date
    //       ? `${dayjs(row.finishWorkTime.punched_date).format(
    //           "MMM-DD, YYYY"
    //         )} ${formatTime(row.finishWorkTime.punched_time)}`
    //       : formatTime(row.finishWorkTime.punched_time)
    //     : "Pending",
    // }));
    const tableData = coursings.map((row, index) => {
      const start = formatTime(row.schedule?.startTime) || " ";
      const end = formatTime(row.schedule?.endTime) || " ";
      const spansNextDay = row.schedule?.spansNextDay ? " [next day]" : "";
      const updateStatus =
        row.schedule && row.schedule.schedule_end_date
          ? row.schedule.status === "deleted"
            ? "[D]"
            : row.schedule.schedule_end_date &&
              row.schedule.status === "updated"
            ? "[Up]"
            : ""
          : "";

      const scheduleText = `${start} - ${end}${spansNextDay}${updateStatus}`;

      const formatBreaks = (
        breaks: (string | [string, string])[] | null | undefined,
        breakHourKey: "fristbreakhour" | "secoundbreakhour"
      ) => {
        if (!Array.isArray(breaks) || breaks.length === 0) return " ";

        return breaks
          .map((time) => {
            let punchOut: string | undefined;
            let punchIn: string | undefined;

            if (Array.isArray(time)) {
              [punchOut, punchIn] = time;
            } else {
              punchOut = time;
              punchIn = undefined;
            }

            const punchDate = dayjs(row.workStartTime?.punched_date);
            const breakOut = punchOut ? dayjs(punchOut) : null;
            const breakIn = punchIn ? dayjs(punchIn) : null;

            const formatBreak = (t: Dayjs | null) =>
              !t || !t.isValid()
                ? "Pending"
                : (t.isSame(punchDate, "day")
                    ? t.format("h:mm a")
                    : t.format("MMM D, h:mm a")
                  )
                    .replace("am", "a.m.")
                    .replace("pm", "p.m.");

            const isPaidBreak =
              parseFloat(
                (row.workStartTime?.[breakHourKey] ?? "0").toString()
              ) > 0;

            return (
              `${formatBreak(breakOut)} - ${formatBreak(breakIn)}` +
              (breakOut && breakIn && isPaidBreak ? " [PB]" : "")
            );
          })
          .join("; "); // Join multiple breaks with semicolon if needed
      };

      const break1Text = formatBreaks(
        row.workStartTime?.fristBreak,
        "fristbreakhour"
      );
      const break2Text = formatBreaks(
        row.workStartTime?.secoundBreak,
        "secoundbreakhour"
      );

      return {
        "#": index + 1,
        Name: teamMap.get(row.empid)?.name || "",
        Schedule: scheduleText,
        "Clocked Hours": row.workStartTime?.actual_punched_time
          ? `${formatTime(row.workStartTime.actual_punched_time)} - ${
              row.finishWorkTime?.actual_punched_time
                ? formatTime(row.finishWorkTime.actual_punched_time)
                : "Pending"
            }`
          : " ",
        "Total Hours": `${row.actualHoursAndMin}`,
        "Punch In": formatTime(row.workStartTime?.punched_time) || "Pending",
        "Punch Out": row.finishWorkTime?.punched_time
          ? row.workStartTime?.punched_date !== row.finishWorkTime.punched_date
            ? `${dayjs(row.finishWorkTime.punched_date).format(
                "MMM-DD, YYYY"
              )} ${formatTime(row.finishWorkTime.punched_time)}`
            : formatTime(row.finishWorkTime.punched_time)
          : "Pending",
        "Adjusted Total Hours": `${row.totalHourAndMin}`,
        // "Break 1": break1Text,
        // "Break 2": break2Text,
      };
    });

    const worksheet = XLSX.utils.json_to_sheet(tableData);
    const formattedDate = selectedDate?.format("MMM-DD, YYYY");
    const workbook = XLSX.utils.book_new();
    // XLSX.utils.book_append_sheet(workbook, worksheet, "ClockIn/OutList");
    XLSX.utils.book_append_sheet(workbook, worksheet, "ClockInOutList");
    const fileName = `ClockInOutList_${formattedDate}.xlsx`;

    XLSX.writeFile(workbook, fileName);
  };

  const handleExportToPDF = () => {
    // const tableData = coursings.map((row, index) => [
    //   index + 1,
    //   teamMap.get(row.empid)?.name || "",
    //   `${formatTime(row.schedule?.startTime) || " "} - ${
    //     formatTime(row.schedule?.endTime) || " "
    //   }`,
    //   row.workStartTime?.actual_punched_time
    //     ? `${formatTime(row.workStartTime.actual_punched_time)} - ${
    //         row.finishWorkTime?.actual_punched_time
    //           ? formatTime(row.finishWorkTime.actual_punched_time)
    //           : "Pending"
    //       }`
    //     : " ",
    //   formatTime(row.workStartTime?.punched_time) || "Pending",
    //   // formatTime(row.finishWorkTime?.punched_time) || "Pending",
    //   row.finishWorkTime?.punched_time
    //     ? row.workStartTime?.punched_date !== row.finishWorkTime.punched_date
    //       ? `${dayjs(row.finishWorkTime.punched_date).format(
    //           "MMM-DD, YYYY"
    //         )} ${formatTime(row.finishWorkTime.punched_time)}`
    //       : formatTime(row.finishWorkTime.punched_time)
    //     : "Pending",
    // ]);
    const tableData = coursings.map((row, index) => {
      const start = formatTime(row.schedule?.startTime) || " ";
      const end = formatTime(row.schedule?.endTime) || " ";
      const spansNextDay = row.schedule?.spansNextDay ? " [next day]" : "";
      const updateStatus =
        row.schedule && row.schedule.schedule_end_date
          ? row.schedule.status === "deleted"
            ? "[D]"
            : row.schedule.schedule_end_date &&
              row.schedule.status === "updated"
            ? "[Up]"
            : ""
          : "";

      const scheduleText = `${start} - ${end}${spansNextDay}${updateStatus}`;

      // Helper to format break pairs into string
      const formatBreaks = (
        breaks: (string | [string, string])[] | null | undefined,
        breakHourKey: "fristbreakhour" | "secoundbreakhour"
      ) => {
        if (!Array.isArray(breaks) || breaks.length === 0) return " ";

        return breaks
          .map((time) => {
            let punchOut: string | undefined;
            let punchIn: string | undefined;

            if (Array.isArray(time)) {
              [punchOut, punchIn] = time;
            } else {
              punchOut = time;
              punchIn = undefined;
            }

            const punchDate = dayjs(row.workStartTime?.punched_date);
            const breakOut = punchOut ? dayjs(punchOut) : null;
            const breakIn = punchIn ? dayjs(punchIn) : null;

            const formatBreak = (t: Dayjs | null) =>
              !t || !t.isValid()
                ? "Pending"
                : (t.isSame(punchDate, "day")
                    ? t.format("h:mm a")
                    : t.format("MMM D, h:mm a")
                  )
                    .replace("am", "a.m.")
                    .replace("pm", "p.m.");

            const isPaidBreak =
              parseFloat(
                (row.workStartTime?.[breakHourKey] ?? "0").toString()
              ) > 0;

            return (
              `${formatBreak(breakOut)} - ${formatBreak(breakIn)}` +
              (breakOut && breakIn && isPaidBreak ? " [PB]" : "")
            );
          })
          .join("; "); // Join multiple breaks with semicolon if needed
      };

      const break1Text = formatBreaks(
        row.workStartTime?.fristBreak,
        "fristbreakhour"
      );
      const break2Text = formatBreaks(
        row.workStartTime?.secoundBreak,
        "secoundbreakhour"
      );

      return [
        index + 1,
        teamMap.get(row.empid)?.name || "",
        scheduleText,
        row.workStartTime?.actual_punched_time
          ? `${formatTime(row.workStartTime.actual_punched_time)} - ${
              row.finishWorkTime?.actual_punched_time
                ? formatTime(row.finishWorkTime.actual_punched_time)
                : "Pending"
            }`
          : " ",
        `${row.actualHoursAndMin}`,
        formatTime(row.workStartTime?.punched_time) || "Pending",
        row.finishWorkTime?.punched_time
          ? row.workStartTime?.punched_date !== row.finishWorkTime.punched_date
            ? `${dayjs(row.finishWorkTime.punched_date).format(
                "MMM-DD, YYYY"
              )} ${formatTime(row.finishWorkTime.punched_time)}`
            : formatTime(row.finishWorkTime.punched_time)
          : "Pending",
        `${row.totalHourAndMin}`,
        // break1Text,
        // break2Text,
      ];
    });

    const tableHeaders = [
      [
        "#",
        "Name",
        "Schedule",
        "Clocked Hours",
        "Total Hours",
        "Punch In",
        "Punch Out",
        "Adjusted Total Hours",
        // "Break 1",
        // "Break 2",
      ],
    ];

    const currentMonth = dayjs().format("YYYY MMM, DD");

    const doc = new jsPDF("l", "mm", "a4");
    const formattedDate = selectedDate?.format("MMM-DD, YYYY");

    const imageUrl = companyLogo;
    const pageWidth = doc.internal.pageSize.width;
    const imgWidth = logowidthPrint;
    const imgHeight = 10;
    // const imgX = (pageWidth - imgWidth) / 2;
    const imgY = 10;
    const imgX = 15;

    const img = new Image();
    img.src = imageUrl;
    img.onload = () => {
      doc.addImage(img, "PNG", imgX, imgY, imgWidth, imgHeight);

      const textStartY = imgY + imgHeight / 2;

      const centerText = (text: string, y: number) => {
        const textWidth = doc.getTextWidth(text);
        const textX = (pageWidth - textWidth) / 2;
        doc.text(text, textX, y);
      };

      const rightAlignText = (text: string, y: number) => {
        doc.setFontSize(10);
        const textWidth = doc.getTextWidth(text);
        const textX = pageWidth - textWidth - 15;
        doc.text(text, textX, y);
      };

      doc.setFontSize(10);
      doc.setFont("helvetica", "normal");
      rightAlignText(`Clock In/Out List`, textStartY);

      doc.setFontSize(10);
      doc.setFont("helvetica", "normal");
      rightAlignText(`Date: ${formattedDate}`, textStartY + 5);

      (doc as any).autoTable({
        head: tableHeaders,
        body: tableData,
        startY: textStartY + 15,
        theme: "grid",
        styles: { fontSize: 8 },
        headStyles: { fillColor: [200, 200, 200] },
        alternateRowStyles: { fillColor: [245, 245, 245] },
      });

      const fileName = `ClockIn/OutList_${formattedDate}.pdf`;

      doc.save(fileName);
    };
  };

  const hasActionsColumn = coursings.some(
    (row) =>
      userHasRight(Privileges.ScheduleEdit) &&
      row.workStartTime &&
      (row.workStartTime.id ||
        row.finishWorkTime?.isValidPunchRecord === "notValiedRecord") &&
      row.workStartTime.isGeneratePayroll == false
  );

  const hasRecords =
    (outOfLocationRecords?.length ?? 0) > 0 ||
    (dashboardData?.data?.invalidPunchRecords?.length ?? 0) > 0 ||
    (dashboardData?.data?.missingPunchOutTime?.length ?? 0) > 0;

  // Count how many record types have data
  const recordTypes = [
    outOfLocationRecords?.length ?? 0,
    dashboardData?.data?.invalidPunchRecords?.length ?? 0,
    dashboardData?.data?.missingPunchOutTime?.length ?? 0,
  ];

  // Filter only those with length > 0
  const activeRecordCount = recordTypes.filter((count) => count > 0).length;

  // Calculate column width
  const colWidth =
    activeRecordCount > 0 ? Math.floor(12 / activeRecordCount) : 12;

  const maincolWidth = activeRecordCount == 1 ? 6 : 12;
  const mainSubcolWidth = activeRecordCount == 1 ? 6 : 3;


  if (
    userIsLoading ||
    dashboardIsLoading ||
    tenantIsLoading ||
    deleteRecordIsLoadig ||
    outOfLocationIsLoadig
  ) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" height="10vh">
                      <StepUpSpinner size="medium" />
                    </Box>
    );
  }

  return (
    <Grid container spacing={3}>
      <Grid item lg={12} md={12} sm={12} xs={12}>
        <Grid container spacing={2}>
          <Grid item lg={maincolWidth} md={12} sm={12} xs={12}>
            <Grid container spacing={2}>
              <Grid item lg={mainSubcolWidth} md={3} sm={12} xs={12}>
                <Card className={classes.staffDhashboardSmallCardUpdate}>
                  <Grid container spacing={2}>
                    <Grid
                      item
                      lg={6}
                      md={6}
                      sm={6}
                      xs={6}
                      className={classes.dashboardfristCardGrid}
                    >
                      <Box className={classes.dashboardfristCardButton}>
                        <SouthIcon
                          className={classes.dashboardfristCardButtonIcon}
                        />
                      </Box>
                    </Grid>
                    <Grid
                      item
                      lg={6}
                      md={6}
                      sm={6}
                      xs={6}
                      className={classes.dashboardfristCardGrid}
                    >
                      <Typography
                        className={classes.dashboardfristCardButtonText1}
                      >
                        Clock In
                      </Typography>
                      <Typography
                        className={classes.dashboardfristCardButtonText2}
                      >
                        {dashboardData?.data.total_punch_in}
                      </Typography>
                    </Grid>
                  </Grid>
                </Card>
              </Grid>
              <Grid item lg={mainSubcolWidth} md={3} sm={12} xs={12}>
                <Card className={classes.staffDhashboardSmallCardUpdate}>
                  <Grid container spacing={2}>
                    <Grid
                      item
                      lg={6}
                      md={6}
                      sm={6}
                      xs={6}
                      className={classes.dashboardfristCardGrid}
                    >
                      <Box className={classes.dashboardfristCardButton}>
                        <NorthIcon
                          className={classes.dashboardfristCardButtonIcon}
                        />
                      </Box>
                    </Grid>
                    <Grid
                      item
                      lg={6}
                      md={6}
                      sm={6}
                      xs={6}
                      className={classes.dashboardfristCardGrid}
                    >
                      <Typography
                        className={classes.dashboardfristCardButtonText1}
                      >
                        Clock Out
                      </Typography>
                      <Typography
                        className={classes.dashboardfristCardButtonText2}
                      >
                        {dashboardData?.data.total_punch_out}
                      </Typography>
                    </Grid>
                  </Grid>
                </Card>
              </Grid>
              <Grid item lg={mainSubcolWidth} md={3} sm={12} xs={12}>
                <Card className={classes.staffDhashboardSmallCardUpdate}>
                  <Grid container spacing={2}>
                    <Grid
                      item
                      lg={6}
                      md={6}
                      sm={6}
                      xs={6}
                      className={classes.dashboardfristCardGrid}
                    >
                      <Box className={classes.dashboardfristCardButton}>
                        <Groups2OutlinedIcon
                          className={classes.dashboardfristCardButtonIcon}
                        />
                      </Box>
                    </Grid>
                    <Grid
                      item
                      lg={6}
                      md={6}
                      sm={6}
                      xs={6}
                      className={classes.dashboardfristCardGrid}
                    >
                      <Typography
                        className={classes.dashboardfristCardButtonText1}
                      >
                        Staff
                      </Typography>
                      <Typography
                        className={classes.dashboardfristCardButtonText2}
                      >
                        {dashboardData?.data.active_employees}
                      </Typography>
                    </Grid>
                  </Grid>
                </Card>
              </Grid>
              <Grid item lg={mainSubcolWidth} md={3} sm={12} xs={12}>
                <Card className={classes.staffDhashboardSmallCardUpdate}>
                  <Grid container spacing={2}>
                    <Grid
                      item
                      lg={6}
                      md={6}
                      sm={6}
                      xs={6}
                      className={classes.dashboardfristCardGrid}
                    >
                      <Box className={classes.dashboardfristCardButton}>
                        <CheckCircleOutlinedIcon
                          className={classes.dashboardfristCardButtonIcon}
                        />
                      </Box>
                    </Grid>
                    <Grid
                      item
                      lg={6}
                      md={6}
                      sm={6}
                      xs={6}
                      className={classes.dashboardfristCardGrid}
                    >
                      <Typography
                        className={classes.dashboardfristCardButtonText1}
                      >
                        Active
                      </Typography>
                      <Typography
                        className={classes.dashboardfristCardButtonText2}
                      >
                        {dashboardData?.data.status_counts?.[1] ?? 0}
                      </Typography>
                    </Grid>
                  </Grid>
                </Card>
              </Grid>
            </Grid>
          </Grid>
          {hasRecords && (
            <Grid item lg={maincolWidth} md={12} sm={12} xs={12}>
              <Card
                className={classes.staffDhashboardSmallCardUpdate}
                sx={{ minHeight: 200 }}
              >
                <Grid container spacing={2}>
                  {dashboardData?.data.invalidPunchRecords &&
                    dashboardData?.data.invalidPunchRecords?.length > 0 && (
                      <Grid item lg={colWidth} md={12} sm={12} xs={12}>
                        <Grid container spacing={2}>
                          <Grid item lg={12} md={12} sm={12} xs={12}>
                            <Typography
                              className={classes.dashboardfristCardHeading}
                            >
                              <span className={classes.requiedfield}>
                                Please check punch in/out times — invalid
                                record.
                              </span>
                            </Typography>
                          </Grid>
                          <Grid item lg={12} md={12} sm={12} xs={12}>
                            {dashboardIsError ? (
                              <Box textAlign="center" py={4}>
                                <Typography color="error">
                                  Error fetching data
                                </Typography>
                              </Box>
                            ) : dashboardIsLoading ? (
                              <Box
                                display="flex"
                                justifyContent="center"
                                py={4}
                              >
                                <CircularProgress />
                              </Box>
                            ) : dashboardData?.data.invalidPunchRecords
                                ?.length === 0 ? (
                              <Box textAlign="center" py={4}>
                                <Typography>No Record Avilable</Typography>
                              </Box>
                            ) : (
                              <List sx={{ width: "100%" }}>
                                {dashboardData.data.invalidPunchRecords.map(
                                  (record) => (
                                    <Grid item xs={12} key={record.id}>
                                      <Link
                                        to={`/schedule/list?date=${dayjs(
                                          record.punch_in_date
                                        ).format("YYYY-MM-DD")}`}
                                        className={classes.iconLinkPropNormal}
                                      >
                                        <Card
                                          onClick={() =>
                                            navigate(
                                              `/schedule/list?date=${dayjs(
                                                record.punch_in_date
                                              ).format("YYYY-MM-DD")}`
                                            )
                                          }
                                          elevation={0}
                                          sx={{
                                            background:
                                              theme.palette.cardAdd.bgColor,
                                            display: "flex",
                                            alignItems: "center",
                                            p: 1,
                                            py: 1,
                                            cursor: "pointer",
                                            transition: "background 0.2s",
                                            "&:hover": {
                                              backgroundColor:
                                                theme.palette.action.hover,
                                            },
                                          }}
                                        >
                                          <Badge
                                            color="primary"
                                            sx={{
                                              mr: 2,
                                              "& .MuiBadge-badge": {
                                                fontSize: "0.75rem",
                                                minWidth: 20,
                                                height: 20,
                                                borderRadius: "50%",
                                                backgroundColor: "green",
                                                color: "#fff",
                                              },
                                            }}
                                          >
                                            <Avatar
                                              sx={{
                                                bgcolor: "primary.main",
                                              }}
                                            >
                                              {teamMap.get(record.empid)
                                                ?.name ? (
                                                `${
                                                  teamMap.get(record.empid)
                                                    ?.name
                                                }`
                                                  .trim()
                                                  .charAt(0)
                                                  .toUpperCase()
                                              ) : (
                                                <GroupIcon />
                                              )}
                                            </Avatar>
                                          </Badge>

                                          <Box>
                                            <Typography>
                                              {teamMap.get(record.empid)
                                                ?.name || ""}
                                            </Typography>
                                            <Typography
                                              variant="body2"
                                              sx={{
                                                fontSize: "0.875rem",
                                                color: "#444",
                                              }}
                                            >
                                              Punch In:{" "}
                                              <strong>
                                                {dayjs(
                                                  record.punch_in_date
                                                ).format("MMM DD")}{" "}
                                                {formatTime(
                                                  record.punch_in_time
                                                )}
                                              </strong>{" "}
                                              | Out:{" "}
                                              <strong>
                                                {dayjs(
                                                  record.punch_out_date
                                                ).format("MMM DD")}{" "}
                                                {formatTime(
                                                  record.punch_out_time
                                                )}
                                              </strong>
                                            </Typography>
                                          </Box>
                                        </Card>
                                      </Link>
                                    </Grid>
                                  )
                                )}
                              </List>
                            )}
                          </Grid>
                        </Grid>
                      </Grid>
                    )}
                  {dashboardData?.data.missingPunchOutTime &&
                    dashboardData?.data.missingPunchOutTime?.length > 0 && (
                      <Grid item lg={colWidth} md={12} sm={12} xs={12}>
                        <Grid container spacing={2}>
                          <Grid item lg={12} md={12} sm={12} xs={12}>
                            <Typography
                              className={classes.dashboardfristCardHeading}
                            >
                              <span className={classes.requiedfield}>
                                Incomplete Punch Out Details
                              </span>
                            </Typography>
                          </Grid>
                          <Grid item lg={12} md={12} sm={12} xs={12}>
                            {dashboardIsError ? (
                              <Box textAlign="center" py={4}>
                                <Typography color="error">
                                  Error fetching data
                                </Typography>
                              </Box>
                            ) : dashboardIsLoading ? (
                              <Box
                                display="flex"
                                justifyContent="center"
                                py={4}
                              >
                                <CircularProgress />
                              </Box>
                            ) : dashboardData?.data.missingPunchOutTime
                                ?.length === 0 ? (
                              <Box textAlign="center" py={4}>
                                <Typography>No Record Avilable</Typography>
                              </Box>
                            ) : (
                              <List sx={{ width: "100%" }}>
                                {dashboardData.data.missingPunchOutTime.map(
                                  (record) => (
                                    <Grid item xs={12} key={record.id}>
                                      <Link
                                        to={`/schedule/list?date=${dayjs(
                                          record.punch_in_date
                                        ).format("YYYY-MM-DD")}`}
                                        className={classes.iconLinkPropNormal}
                                      >
                                        <Card
                                          onClick={() =>
                                            navigate(
                                              `/schedule/list?date=${dayjs(
                                                record.punch_in_date
                                              ).format("YYYY-MM-DD")}`
                                            )
                                          }
                                          elevation={0}
                                          sx={{
                                            background:
                                              theme.palette.cardAdd.bgColor,
                                            display: "flex",
                                            alignItems: "center",
                                            p: 1,
                                            py: 1,
                                            cursor: "pointer",
                                            transition: "background 0.2s",
                                            "&:hover": {
                                              backgroundColor:
                                                theme.palette.action.hover,
                                            },
                                          }}
                                        >
                                          <Badge
                                            color="primary"
                                            sx={{
                                              mr: 2,
                                              "& .MuiBadge-badge": {
                                                fontSize: "0.75rem",
                                                minWidth: 20,
                                                height: 20,
                                                borderRadius: "50%",
                                                backgroundColor: "green",
                                                color: "#fff",
                                              },
                                            }}
                                          >
                                            <Avatar
                                              sx={{
                                                bgcolor: "primary.main",
                                              }}
                                            >
                                              {teamMap.get(record.empid)
                                                ?.name ? (
                                                `${
                                                  teamMap.get(record.empid)
                                                    ?.name
                                                }`
                                                  .trim()
                                                  .charAt(0)
                                                  .toUpperCase()
                                              ) : (
                                                <GroupIcon />
                                              )}
                                            </Avatar>
                                          </Badge>

                                          <Box>
                                            <Typography>
                                              {teamMap.get(record.empid)
                                                ?.name || ""}
                                            </Typography>
                                            <Typography
                                              variant="body2"
                                              sx={{
                                                fontSize: "0.875rem",
                                                color: "#444",
                                              }}
                                            >
                                              Punch In:{" "}
                                              <strong>
                                                {dayjs(
                                                  record.punch_in_date
                                                ).format("MMM DD")}{" "}
                                                {formatTime(
                                                  record.punch_in_time
                                                )}
                                              </strong>{" "}
                                              | Out:{" "}
                                              <strong
                                                style={{
                                                  color: "#e3791a",
                                                }}
                                              >
                                                . Pending
                                              </strong>
                                            </Typography>
                                          </Box>
                                        </Card>
                                      </Link>
                                    </Grid>
                                  )
                                )}
                              </List>
                            )}
                          </Grid>
                        </Grid>
                      </Grid>
                    )}
                  {outOfLocationRecords && outOfLocationRecords?.length > 0 && (
                    <Grid item lg={colWidth} md={12} sm={12} xs={12}>
                      <Grid container spacing={2}>
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          <Typography
                            className={classes.dashboardfristCardHeading}
                          >
                            <span className={classes.requiedfield}>
                              Please review today’s out-of-location punch
                              in/out.
                            </span>
                          </Typography>
                        </Grid>
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                          {outOfLocationIsError ? (
                            <Box textAlign="center" py={4}>
                              <Typography color="error">
                                Error fetching data
                              </Typography>
                            </Box>
                          ) : outOfLocationIsLoadig ? (
                            <Box display="flex" justifyContent="center" py={4}>
                              <CircularProgress />
                            </Box>
                          ) : outOfLocationRecords?.length === 0 ? (
                            <Box textAlign="center" py={4}>
                              <Typography>No Record Avilable</Typography>
                            </Box>
                          ) : (
                            <List sx={{ width: "100%" }}>
                              {outOfLocationRecords.map((record) => (
                                <Grid item xs={12} key={record.id}>
                                  <Link
                                    to={`/schedule/list?date=${dayjs(
                                      record.date
                                    ).format("YYYY-MM-DD")}`}
                                    className={classes.iconLinkPropNormal}
                                  >
                                    <Card
                                      onClick={() =>
                                        navigate(
                                          `/schedule/list?date=${dayjs(
                                            record.date
                                          ).format("YYYY-MM-DD")}`
                                        )
                                      }
                                      elevation={0}
                                      sx={{
                                        background:
                                          theme.palette.cardAdd.bgColor,
                                        display: "flex",
                                        alignItems: "center",
                                        p: 1,
                                        py: 1,
                                        cursor: "pointer",
                                        transition: "background 0.2s",
                                        "&:hover": {
                                          backgroundColor:
                                            theme.palette.action.hover,
                                        },
                                      }}
                                    >
                                      <Badge
                                        color="primary"
                                        sx={{
                                          mr: 2,
                                          "& .MuiBadge-badge": {
                                            fontSize: "0.75rem",
                                            minWidth: 20,
                                            height: 20,
                                            borderRadius: "50%",
                                            backgroundColor: "green",
                                            color: "#fff",
                                          },
                                        }}
                                      >
                                        <Avatar
                                          sx={{
                                            bgcolor: "primary.main",
                                          }}
                                        >
                                          {teamMap.get(record.empid)?.name ? (
                                            `${teamMap.get(record.empid)?.name}`
                                              .trim()
                                              .charAt(0)
                                              .toUpperCase()
                                          ) : (
                                            <GroupIcon />
                                          )}
                                        </Avatar>
                                      </Badge>

                                      <Box>
                                        <Typography>
                                          {teamMap.get(record.empid)?.name ||
                                            ""}
                                        </Typography>
                                        <Typography
                                          variant="body2"
                                          sx={{
                                            fontSize: "0.875rem",
                                            color: "#444",
                                          }}
                                        >
                                          <strong>
                                            <span
                                              style={{
                                                color: "#e3791a",
                                                fontWeight: 600,
                                              }}
                                            >
                                              {`${record.status} | `}{" "}
                                            </span>
                                          </strong>
                                          {`${dayjs(record.date).format(
                                            "MMM DD, YYYY"
                                          )} | `}
                                          {` ${formatTime(record.time)}`}
                                        </Typography>
                                      </Box>
                                    </Card>
                                  </Link>
                                </Grid>
                              ))}
                            </List>
                          )}
                        </Grid>
                      </Grid>
                    </Grid>
                  )}
                </Grid>
              </Card>
            </Grid>
          )}
        </Grid>
      </Grid>
      <>
        {isMobileRes ? (
          <Grid item lg={12} md={12} sm={12} xs={12}>
            <Card className={classes.card}>
              <Grid
                container
                justifyContent={"space-between"}
                spacing={2}
                sx={{ padding: 2 }}
                className={classes.titleGrid}
              >
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <Grid container spacing={1}>
                    <Grid item>
                      <List className={classes.ListPayroll}>
                        <ListItem className={classes.ListItemPayroll}>
                          <IconButton
                            // color="primary"
                            onClick={goToPreviousDay}
                            aria-label="Previous Day"
                          >
                            <KeyboardArrowLeftIcon />
                          </IconButton>
                        </ListItem>
                        <ListItem className={classes.ListItemPayroll}>
                          <Button
                            className={classes.ListItemPayrollToday}
                            // onClick={goToToday}
                            aria-label="Today"
                          >
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                              <DatePicker
                                value={selectedDate}
                                onChange={handleDateChange}
                                slotProps={{
                                  textField: {
                                    placeholder: "Date of Birth",
                                    size: "small",
                                    sx: {
                                      width: "140px",
                                    },
                                    InputProps: {
                                      sx: {
                                        fontSize: 14,
                                        color: "#97c3df",
                                      },
                                      // classes: {
                                      //   // root: classes.textFieldQuote,
                                      // },
                                      classes: {
                                        root: classes.formControlListStatus,
                                        notchedOutline: classes.notchedOutline,
                                      },
                                    },
                                    InputLabelProps: {
                                      sx: {
                                        fontSize: 14,
                                        color: "#97c3df",
                                      },
                                    },
                                  },
                                }}
                              />
                            </LocalizationProvider>
                          </Button>
                        </ListItem>
                        <ListItem className={classes.ListItemPayroll}>
                          <IconButton
                            // color="primary"
                            onClick={goToNextDay}
                            aria-label="Next Day"
                          >
                            <KeyboardArrowRightIcon />
                          </IconButton>
                        </ListItem>
                      </List>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid
                  item
                  lg={12}
                  md={12}
                  sm={12}
                  xs={12}
                  // sx={{ display: "flex", justifyContent: "flex-end" }}
                >
                  <Grid
                    container
                    spacing={1}
                    // justifyContent="flex-end"
                    // sx={{
                    //   display: "flex",
                    //   justifyContent: "flex-end",
                    // }}
                  >
                    <Grid item>
                      <Button
                        // variant="contained"
                        startIcon={<TableViewIcon />}
                        className={classes.addButtonPdfExcel}
                        onClick={handleExportToExcel}
                      >
                        Excel
                      </Button>
                    </Grid>
                    <Grid item>
                      <Button
                        // variant="contained"
                        startIcon={<LocalPrintshopSharpIcon />}
                        className={classes.addButtonPdfExcel}
                        onClick={handleExportToPDF}
                      >
                        pdf
                      </Button>
                    </Grid>
                    <Grid item>
                      <Link
                        to={`/attendance/create?date=${paymentMonthYear.format(
                          "YYYY-MM-DD"
                        )}`}
                        className={classes.iconLinkPropNormal}
                      >
                        <Button
                          // variant="contained"
                          className={classes.addNewButton}
                          onClick={handleAddProductClick}
                        >
                          Add New
                        </Button>
                      </Link>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>

              <Grid>
                <TableContainer>
                  <Table className={classes.table}>
                    <TableHead className={classes.tableHeaderRow}>
                      <TableRow>
                        <TableCell className={classes.tablheader}>
                          <strong>Name</strong>
                        </TableCell>

                        <TableCell
                          className={classes.tablheader}
                          // sx={{ textAlign: "center" }}
                        >
                          <strong>Punch In / Out</strong>
                        </TableCell>
                        {hasActionsColumn &&
                          userHasRight(Privileges.ScheduleEdit) && (
                            <TableCell
                              className={classes.tablheader}
                              sx={{ textAlign: "right" }}
                            >
                              <strong>Actions</strong>
                            </TableCell>
                          )}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {isLoading || tenantIsLoading ? (
                        <TableRow>
                          <TableCell colSpan={20} align="center">
                            <Box display="flex" justifyContent="center" alignItems="center" height="10vh">
                      <StepUpSpinner size="medium" />
                    </Box>
                          </TableCell>
                        </TableRow>
                      ) : isError || coursings.length === 0 ? (
                        <TableRow>
                          <TableCell colSpan={20} align="center">
                            {isError
                              ? "Error fetching data"
                              : "No data available"}
                          </TableCell>
                        </TableRow>
                      ) : (
                        coursings
                          .slice(
                            page * rowsPerPage,
                            page * rowsPerPage + rowsPerPage
                          )
                          .map((row: IScheduleListDetails, index) => (
                            <TableRow
                              key={index}
                              className={classes.tableRowHover}
                              // sx={{
                              //   backgroundColor:
                              //     !row.workStartTime?.punched_time &&
                              //     row.schedule?.startTime &&
                              //     dayjs(
                              //       `2000-01-01T${row.schedule?.startTime}`
                              //     ).isBefore(
                              //       dayjs(`2000-01-01T${dayjs().format("HH:mm")}`)
                              //     )
                              //       ? "#f5e5e5c4"
                              //       : "transparent",
                              // }}

                              sx={{
                                backgroundColor:
                                  row.finishWorkTime?.isValidPunchRecord ===
                                  "notValiedRecord"
                                    ? "transparent" // treat invalid as valid - no red background or error style
                                    : undefined, // default styles for other statuses
                              }}
                            >
                              <TableCell
                                component="th"
                                scope="row"
                                className={classes.tablCell}
                              >
                                {" "}
                                <Grid container spacing={1}>
                                  <Grid item>
                                    <Link
                                      to={`/team-history/${row.empid}`}
                                      className={classes.iconLinkPropNormal}
                                    >
                                      <Typography
                                        className={classes.nameTableList}
                                      >
                                        {teamMap.get(row.empid)?.name || ""}
                                        {/* <span
                                          style={{
                                            cursor: "pointer",
                                            display: "inline-flex",
                                            alignItems: "center",
                                            paddingLeft: "5px",
                                          }}
                                        >
                                          <FontAwesomeIcon
                                            icon={faUser}
                                            style={{ color: "#1976d2" }}
                                          />
                                        </span> */}
                                      </Typography>
                                    </Link>
                                    <Typography
                                      className={classes.mobileListText}
                                    >
                                      {formatTime(row.schedule?.startTime)} -{" "}
                                      {formatTime(row.schedule?.endTime)}{" "}
                                      {row.schedule &&
                                        row.schedule.spansNextDay == true && (
                                          <span
                                            style={{
                                              color: "#e3791a",
                                              fontWeight: 600,
                                              // lineHeight: 1.5,
                                              // fontSize: "0.875rem",
                                              paddingLeft: "1px",
                                            }}
                                          >
                                            [next day]
                                          </span>
                                        )}
                                      {row.schedule &&
                                      row.schedule.schedule_end_date ? (
                                        row.schedule.status === "deleted" ? (
                                          <span
                                            style={{
                                              color: "#d32f2f", // red
                                              fontWeight: 600,
                                              paddingLeft: "1px",
                                            }}
                                          >
                                            [D]
                                          </span>
                                        ) : row.schedule.schedule_end_date &&
                                          row.schedule.status === "updated" ? (
                                          <span
                                            style={{
                                              color: "#1976d2",
                                              fontWeight: 600,
                                              paddingLeft: "1px",
                                            }}
                                          >
                                            [Up]
                                          </span>
                                        ) : null
                                      ) : null}
                                      {row.schedule &&
                                        row.schedule.total_scheduled_hours && (
                                          <span
                                            style={{
                                              color: "#28a745",
                                              fontWeight: 600,
                                              paddingLeft: "1px",
                                            }}
                                          >
                                            {`(${row.schedule.total_scheduled_hours}h)`}
                                          </span>
                                        )}
                                    </Typography>
                                    <Typography
                                      className={classes.mobileListText}
                                    >
                                      <>
                                        <span
                                          style={{
                                            color: "#1976d2",
                                            fontWeight: 600,
                                            paddingLeft: "1px",
                                          }}
                                        >
                                          {"clocked: "}
                                        </span>
                                        {row.workStartTime
                                          ?.actual_punched_time ? (
                                          <>
                                            {formatTime(
                                              row.workStartTime
                                                .actual_punched_time
                                            )}{" "}
                                            -{" "}
                                            {row.finishWorkTime
                                              ?.actual_punched_time
                                              ? formatTime(
                                                  row.finishWorkTime
                                                    .actual_punched_time
                                                )
                                              : "Pending"}
                                          </>
                                        ) : (
                                          <>
                                            {dayjs(paymentMonthYear).format(
                                              "YYYY-MM-DD"
                                            ) ===
                                              dayjs().format("YYYY-MM-DD") &&
                                              row.schedule?.startTime &&
                                              (() => {
                                                const now = dayjs();
                                                const scheduleStart = dayjs(
                                                  row.schedule.startTime,
                                                  "HH:mm"
                                                );

                                                if (
                                                  now.isAfter(scheduleStart)
                                                ) {
                                                  return (
                                                    <QuestionMarkIcon
                                                      className={
                                                        classes.badgePulse
                                                      }
                                                      sx={{
                                                        fontSize: 14,
                                                        color: "error.main",
                                                        borderRadius: "50%",
                                                      }}
                                                    />
                                                  );
                                                }

                                                return null;
                                              })()}
                                          </>
                                        )}
                                        <br />
                                        {row.workStartTime && (
                                          <>
                                            {Array.isArray(
                                              row.workStartTime.fristBreak
                                            ) &&
                                              row.workStartTime.fristBreak.map(
                                                (
                                                  time:
                                                    | string
                                                    | [string, string],
                                                  index: number
                                                ) => {
                                                  let punchOut:
                                                    | string
                                                    | undefined;
                                                  let punchIn:
                                                    | string
                                                    | undefined;

                                                  // Support both ["out", "in"] or just ["out"]
                                                  if (Array.isArray(time)) {
                                                    [punchOut, punchIn] = time;
                                                  } else {
                                                    punchOut = time;
                                                    punchIn = undefined;
                                                  }

                                                  const punchDate = dayjs(
                                                    row.workStartTime
                                                      ?.punched_date
                                                  );
                                                  const breakOut = punchOut
                                                    ? dayjs(punchOut)
                                                    : null;
                                                  const breakIn = punchIn
                                                    ? dayjs(punchIn)
                                                    : null;

                                                  const formatBreak = (
                                                    t: Dayjs | null
                                                  ) =>
                                                    !t || !t.isValid()
                                                      ? "Pending"
                                                      : (t.isSame(
                                                          punchDate,
                                                          "day"
                                                        )
                                                          ? t.format("h:mm a")
                                                          : t.format(
                                                              "MMM D, h:mm a"
                                                            )
                                                        )
                                                          .replace("am", "a.m.")
                                                          .replace(
                                                            "pm",
                                                            "p.m."
                                                          );
                                                  const isPaidBreak =
                                                    parseFloat(
                                                      (
                                                        row.workStartTime
                                                          ?.fristbreakhour ??
                                                        "0"
                                                      ).toString()
                                                    ) > 0;

                                                  return (
                                                    <Typography
                                                      key={`break1-${index}`}
                                                      sx={{
                                                        // color:"#007f00",
                                                        fontWeight: 600,
                                                        lineHeight: 1.5,
                                                        fontSize: "0.875rem",
                                                        paddingLeft: "1px",
                                                        // fontStyle: "italic",
                                                        marginTop: 0.5,
                                                      }}
                                                      color="textSecondary"
                                                    >
                                                      Break 1:{" "}
                                                      {formatBreak(breakOut)} -{" "}
                                                      {formatBreak(breakIn)}
                                                      {breakOut &&
                                                        breakIn &&
                                                        isPaidBreak && (
                                                          <strong
                                                            style={{
                                                              color: "#007f00",
                                                            }}
                                                          >{` [PB]`}</strong>
                                                        )}
                                                    </Typography>
                                                  );
                                                }
                                              )}

                                            {/* Break 2 */}
                                            {Array.isArray(
                                              row.workStartTime.secoundBreak
                                            ) &&
                                              row.workStartTime.secoundBreak.map(
                                                (
                                                  time:
                                                    | string
                                                    | [string, string],
                                                  index: number
                                                ) => {
                                                  let punchOut:
                                                    | string
                                                    | undefined;
                                                  let punchIn:
                                                    | string
                                                    | undefined;

                                                  // Support both ["out", "in"] or just ["out"]
                                                  if (Array.isArray(time)) {
                                                    [punchOut, punchIn] = time;
                                                  } else {
                                                    punchOut = time;
                                                    punchIn = undefined;
                                                  }

                                                  const punchDate = dayjs(
                                                    row.workStartTime
                                                      ?.punched_date
                                                  );
                                                  const breakOut = punchOut
                                                    ? dayjs(punchOut)
                                                    : null;
                                                  const breakIn = punchIn
                                                    ? dayjs(punchIn)
                                                    : null;

                                                  const formatBreak = (
                                                    t: Dayjs | null
                                                  ) =>
                                                    !t || !t.isValid()
                                                      ? "Pending"
                                                      : (t.isSame(
                                                          punchDate,
                                                          "day"
                                                        )
                                                          ? t.format("h:mm a")
                                                          : t.format(
                                                              "MMM D, h:mm a"
                                                            )
                                                        )
                                                          .replace("am", "a.m.")
                                                          .replace(
                                                            "pm",
                                                            "p.m."
                                                          );
                                                  const isPaidBreak =
                                                    parseFloat(
                                                      (
                                                        row.workStartTime
                                                          ?.secoundbreakhour ??
                                                        "0"
                                                      ).toString()
                                                    ) > 0;

                                                  return (
                                                    <Typography
                                                      key={`break1-${index}`}
                                                      sx={{
                                                        // color:"#007f00",
                                                        fontWeight: 600,
                                                        lineHeight: 1.5,
                                                        fontSize: "0.875rem",
                                                        paddingLeft: "1px",
                                                        // fontStyle: "italic",
                                                        marginTop: 0.5,
                                                      }}
                                                      color="textSecondary"
                                                    >
                                                      Break 2:{" "}
                                                      {formatBreak(breakOut)} -{" "}
                                                      {formatBreak(breakIn)}
                                                      {breakOut &&
                                                        breakIn &&
                                                        isPaidBreak && (
                                                          <strong
                                                            style={{
                                                              color: "#007f00",
                                                            }}
                                                          >{` [PB]`}</strong>
                                                        )}
                                                    </Typography>
                                                  );
                                                }
                                              )}
                                          </>
                                        )}
                                      </>
                                    </Typography>
                                  </Grid>
                                </Grid>
                              </TableCell>

                              <TableCell
                                scope="row"
                                className={classes.tablCell}
                                // sx={{ textAlign: "center" }}
                              >
                                <Grid container spacing={2}>
                                  <Grid item>
                                    <Grid
                                      container
                                      spacing={1}
                                      // justifyContent={"center"}
                                    >
                                      <Grid
                                        item
                                        lg={12}
                                        md={12}
                                        sm={12}
                                        xs={12}
                                        sx={{
                                          display: "flex",
                                          // justifyContent: "center",
                                        }}
                                      >
                                        <Box
                                          // className={
                                          //   row.isStartWork === false
                                          //     ? classes.editButtonStatusWaiting
                                          //     : classes.editButtonStatusAvailable
                                          // }
                                          sx={{
                                            cursor: row.workStartTime
                                              ?.punched_time
                                              ? "pointer"
                                              : "pointer",
                                          }}
                                          onClick={() => {
                                            if (
                                              row.workStartTime?.punched_time &&
                                              userHasRight(
                                                Privileges.ScheduleEdit
                                              )
                                            ) {
                                              handleOpenDialogAdminEditPunchIn(
                                                row.workStartTime
                                              );
                                            } else {
                                              handleOpenDialogAdminEdit(
                                                row,
                                                "punch_in"
                                              );
                                            }
                                          }}
                                        >
                                          {userHasRight(
                                            Privileges.ScheduleEdit
                                          ) &&
                                          row.workStartTime?.punched_time ? (
                                            <>
                                              <Tooltip
                                                title={
                                                  <Box
                                                    sx={{ p: 1, maxWidth: 300 }}
                                                  >
                                                    {row.workStartTime
                                                      ?.punchInHistory?.length >
                                                      0 && (
                                                      <Typography
                                                        variant="body2"
                                                        sx={{
                                                          fontWeight: 600,
                                                          mb: 1,
                                                        }}
                                                      >
                                                        Punch-in Edit History
                                                      </Typography>
                                                    )}

                                                    {row.workStartTime
                                                      ?.punchInHistory?.length >
                                                    0 ? (
                                                      row.workStartTime.punchInHistory.map(
                                                        (history) => (
                                                          <Box
                                                            key={history.id}
                                                            sx={{
                                                              mb: 1,
                                                              p: 1,
                                                              borderRadius: 1,
                                                              backgroundColor:
                                                                "#f9f9f9",
                                                              border:
                                                                "1px solid #e0e0e0",
                                                            }}
                                                          >
                                                            <Typography
                                                              variant="body2"
                                                              className={
                                                                classes.tooltipTypograpy
                                                              }
                                                            >
                                                              <strong>
                                                                Date:
                                                              </strong>{" "}
                                                              {dayjs(
                                                                history.date
                                                              ).format(
                                                                "MMM DD, YYYY"
                                                              )}
                                                            </Typography>
                                                            {history.time && (
                                                              <Typography
                                                                variant="body2"
                                                                className={
                                                                  classes.tooltipTypograpy
                                                                }
                                                              >
                                                                <strong>
                                                                  Time:
                                                                </strong>{" "}
                                                                {formatTime(
                                                                  history.time
                                                                )}
                                                              </Typography>
                                                            )}
                                                            {history.status ===
                                                              "Created" && (
                                                              <Typography
                                                                variant="body2"
                                                                className={
                                                                  classes.tooltipTypograpy
                                                                }
                                                              >
                                                                <strong>
                                                                  Method:
                                                                </strong>{" "}
                                                                {history.isFacialPunch
                                                                  ? "Facial"
                                                                  : "Fingerprint"}
                                                              </Typography>
                                                            )}
                                                            {history.status ===
                                                              "AdminCreatedInLocal" && (
                                                              <Typography
                                                                variant="body2"
                                                                className={
                                                                  classes.tooltipTypograpy
                                                                }
                                                              >
                                                                <strong>
                                                                  Method:
                                                                </strong>{" "}
                                                                {history.isFacialPunch
                                                                  ? "Facial Local Admin"
                                                                  : "Fingerprint Local Admin"}
                                                              </Typography>
                                                            )}
                                                            {history.reason && (
                                                              <Typography
                                                                variant="body2"
                                                                className={
                                                                  classes.tooltipTypograpy
                                                                }
                                                              >
                                                                <strong>
                                                                  Reason:
                                                                </strong>{" "}
                                                                {history.reason}
                                                              </Typography>
                                                            )}
                                                            {history.created_by && (
                                                              <Typography
                                                                variant="body2"
                                                                className={
                                                                  classes.tooltipTypograpy
                                                                }
                                                              >
                                                                <strong>
                                                                  Updated By:
                                                                </strong>{" "}
                                                                {userMap.get(
                                                                  history.created_by
                                                                ) || ""}
                                                              </Typography>
                                                            )}
                                                            <Typography
                                                              variant="body2"
                                                              className={
                                                                classes.tooltipTypograpy
                                                              }
                                                            >
                                                              <strong>
                                                                Updated At:
                                                              </strong>{" "}
                                                              {dayjs(
                                                                history.created_at
                                                              ).format(
                                                                "MMM DD, YYYY hh:mm A"
                                                              )}
                                                            </Typography>

                                                            {history.emp_image && (
                                                              <Typography
                                                                variant="body2"
                                                                className={
                                                                  classes.tooltipTypograpy
                                                                }
                                                              >
                                                                <strong>
                                                                  Image:
                                                                </strong>{" "}
                                                                <a
                                                                  href={
                                                                    history.emp_image
                                                                  }
                                                                  target="_blank"
                                                                  rel="noopener noreferrer"
                                                                  style={{
                                                                    color:
                                                                      "#1976d2",
                                                                    textDecoration:
                                                                      "underline",
                                                                  }}
                                                                >
                                                                  View Image
                                                                </a>
                                                              </Typography>
                                                            )}
                                                          </Box>
                                                        )
                                                      )
                                                    ) : (
                                                      <Typography
                                                        variant="body2"
                                                        sx={{
                                                          fontWeight: 600,
                                                          mb: 1,
                                                        }}
                                                      >
                                                        Edit Punch-in
                                                      </Typography>
                                                    )}
                                                  </Box>
                                                }
                                                sx={{ fontSize: "14px" }}
                                              >
                                                <Chip
                                                  sx={{
                                                    cursor: row.workStartTime
                                                      ?.punched_time
                                                      ? "pointer"
                                                      : "pointer",
                                                  }}
                                                  className={
                                                    row.isStartWork === false
                                                      ? classes.editChipWorkFalse
                                                      : classes.editChipWorkTrue
                                                  }
                                                  label={
                                                    <>
                                                      {formatTime(
                                                        row.workStartTime
                                                          .punched_time
                                                      ) || "Pending"}
                                                      <CiEdit
                                                        style={{
                                                          fontSize: 20,
                                                          marginLeft: "5px",
                                                        }}
                                                      />
                                                    </>
                                                  }
                                                />
                                              </Tooltip>
                                            </>
                                          ) : (
                                            <Chip
                                              sx={{
                                                cursor: row.workStartTime
                                                  ?.punched_time
                                                  ? "pointer"
                                                  : "pointer",
                                              }}
                                              className={
                                                row.isFinishWork === false
                                                  ? classes.editChipWorkFalse
                                                  : classes.editChipWorkTrue
                                              }
                                              label={
                                                formatTime(
                                                  row.workStartTime
                                                    ?.punched_time
                                                ) || "Pending"
                                              }
                                            />
                                          )}
                                        </Box>
                                      </Grid>
                                      {row.workStartTime?.punched_time &&
                                        row.workStartTime?.created_by && (
                                          <Grid
                                            item
                                            lg={12}
                                            md={12}
                                            sm={12}
                                            xs={12}
                                            sx={{
                                              display: "flex",
                                              // justifyContent: "center",
                                            }}
                                          >
                                            <Typography
                                              sx={{
                                                fontStyle: "italic",
                                              }}
                                              color="textSecondary"
                                              variant="body2"
                                            >
                                              -- Edited --
                                            </Typography>
                                          </Grid>
                                        )}
                                    </Grid>
                                  </Grid>

                                  <Grid item>
                                    <Grid
                                      container
                                      spacing={1}
                                      // justifyContent={"center"}
                                    >
                                      <Grid
                                        item
                                        lg={12}
                                        md={12}
                                        sm={12}
                                        xs={12}
                                        sx={{
                                          display: "flex",
                                          // justifyContent: "center",
                                        }}
                                      >
                                        <Box
                                          // className={
                                          //   row.isFinishWork === false
                                          //     ? classes.editButtonStatusWaiting
                                          //     : classes.editButtonStatusAvailable
                                          // }
                                          sx={{
                                            cursor: row.finishWorkTime
                                              ?.punched_time
                                              ? "pointer"
                                              : "pointer",
                                          }}
                                          onClick={() => {
                                            if (
                                              row.finishWorkTime
                                                ?.punched_time &&
                                              userHasRight(
                                                Privileges.ScheduleEdit
                                              )
                                            ) {
                                              handleOpenDialogAdminEditPunchOut(
                                                row.finishWorkTime
                                              );
                                            } else if (
                                              row.workStartTime?.punched_time &&
                                              userHasRight(
                                                Privileges.ScheduleEdit
                                              )
                                            ) {
                                              handleOpenDialogAdminEdit(
                                                row,
                                                "punch_out"
                                              );
                                            }
                                          }}
                                        >
                                          {userHasRight(
                                            Privileges.ScheduleEdit
                                          ) &&
                                          row.finishWorkTime?.punched_time ? (
                                            <Tooltip
                                              title={
                                                <Box
                                                  sx={{ p: 1, maxWidth: 300 }}
                                                >
                                                  {row.finishWorkTime
                                                    ?.punchOutHistory?.length >
                                                    0 && (
                                                    <Typography
                                                      variant="body2"
                                                      sx={{
                                                        fontWeight: 600,
                                                        mb: 1,
                                                      }}
                                                    >
                                                      Punch-out Edit History
                                                    </Typography>
                                                  )}

                                                  {row.finishWorkTime
                                                    ?.punchOutHistory?.length >
                                                  0 ? (
                                                    row.finishWorkTime.punchOutHistory.map(
                                                      (history) => (
                                                        <Box
                                                          key={history.id}
                                                          sx={{
                                                            mb: 1,
                                                            p: 1,
                                                            borderRadius: 1,
                                                            backgroundColor:
                                                              "#f9f9f9",
                                                            border:
                                                              "1px solid #e0e0e0",
                                                          }}
                                                        >
                                                          <Typography
                                                            variant="body2"
                                                            className={
                                                              classes.tooltipTypograpy
                                                            }
                                                          >
                                                            <strong>
                                                              Date:
                                                            </strong>{" "}
                                                            {dayjs(
                                                              history.date
                                                            ).format(
                                                              "MMM DD, YYYY"
                                                            )}
                                                          </Typography>
                                                          {history.time && (
                                                            <Typography
                                                              variant="body2"
                                                              className={
                                                                classes.tooltipTypograpy
                                                              }
                                                            >
                                                              <strong>
                                                                Time:
                                                              </strong>{" "}
                                                              {formatTime(
                                                                history.time
                                                              )}
                                                            </Typography>
                                                          )}
                                                          {history.status ===
                                                            "Created" && (
                                                            <Typography
                                                              variant="body2"
                                                              className={
                                                                classes.tooltipTypograpy
                                                              }
                                                            >
                                                              <strong>
                                                                Method:
                                                              </strong>{" "}
                                                              {history.isFacialPunch
                                                                ? "Facial"
                                                                : "Fingerprint"}
                                                            </Typography>
                                                          )}
                                                          {history.status ===
                                                            "AdminCreatedInLocal" && (
                                                            <Typography
                                                              variant="body2"
                                                              className={
                                                                classes.tooltipTypograpy
                                                              }
                                                            >
                                                              <strong>
                                                                Method:
                                                              </strong>{" "}
                                                              {history.isFacialPunch
                                                                ? "Facial Local Admin"
                                                                : "Fingerprint Local Admin"}
                                                            </Typography>
                                                          )}
                                                          {history.reason && (
                                                            <Typography
                                                              variant="body2"
                                                              className={
                                                                classes.tooltipTypograpy
                                                              }
                                                            >
                                                              <strong>
                                                                Reason:
                                                              </strong>{" "}
                                                              {history.reason}
                                                            </Typography>
                                                          )}
                                                          {history.created_by && (
                                                            <Typography
                                                              variant="body2"
                                                              className={
                                                                classes.tooltipTypograpy
                                                              }
                                                            >
                                                              <strong>
                                                                Updated By:
                                                              </strong>{" "}
                                                              {userMap.get(
                                                                history.created_by
                                                              ) || ""}
                                                            </Typography>
                                                          )}
                                                          <Typography
                                                            variant="body2"
                                                            className={
                                                              classes.tooltipTypograpy
                                                            }
                                                          >
                                                            <strong>
                                                              Updated At:
                                                            </strong>{" "}
                                                            {dayjs(
                                                              history.created_at
                                                            ).format(
                                                              "MMM DD, YYYY hh:mm A"
                                                            )}
                                                          </Typography>
                                                          {history.emp_image && (
                                                            <Typography
                                                              variant="body2"
                                                              className={
                                                                classes.tooltipTypograpy
                                                              }
                                                            >
                                                              <strong>
                                                                Image:
                                                              </strong>{" "}
                                                              <a
                                                                href={
                                                                  history.emp_image
                                                                }
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                                style={{
                                                                  color:
                                                                    "#1976d2",
                                                                  textDecoration:
                                                                    "underline",
                                                                }}
                                                              >
                                                                View Image
                                                              </a>
                                                            </Typography>
                                                          )}
                                                        </Box>
                                                      )
                                                    )
                                                  ) : (
                                                    <Typography
                                                      variant="body2"
                                                      sx={{
                                                        fontWeight: 600,
                                                        mb: 1,
                                                      }}
                                                    >
                                                      Edit Punch-out
                                                    </Typography>
                                                  )}
                                                </Box>
                                              }
                                              sx={{ fontSize: "14px" }}
                                            >
                                              <Chip
                                                sx={{
                                                  cursor: row.finishWorkTime
                                                    ?.punched_time
                                                    ? "pointer"
                                                    : "pointer",
                                                }}
                                                className={
                                                  row.isFinishWork === false
                                                    ? classes.editChipWorkFalse
                                                    : classes.editChipWorkTrue
                                                }
                                                label={
                                                  <>
                                                    {row.workStartTime
                                                      ?.punched_date !==
                                                    row.finishWorkTime
                                                      .punched_date
                                                      ? `${dayjs(
                                                          row.finishWorkTime
                                                            .punched_date
                                                        ).format(
                                                          "MMM-DD, YYYY"
                                                        )} ${formatTime(
                                                          row.finishWorkTime
                                                            .punched_time
                                                        )}`
                                                      : formatTime(
                                                          row.finishWorkTime
                                                            .punched_time
                                                        ) || "Pending"}
                                                    <CiEdit
                                                      style={{
                                                        fontSize: 20,
                                                        marginLeft: "5px",
                                                      }}
                                                    />
                                                  </>
                                                }
                                              />
                                            </Tooltip>
                                          ) : (
                                            <Chip
                                              sx={{
                                                cursor:
                                                  row.finishWorkTime
                                                    ?.punched_time ||
                                                  row.workStartTime
                                                    ?.punched_time
                                                    ? "pointer"
                                                    : "default",
                                              }}
                                              className={
                                                row.isFinishWork === false
                                                  ? classes.editChipWorkFalse
                                                  : classes.editChipWorkTrue
                                              }
                                              label={
                                                formatTime(
                                                  row.finishWorkTime
                                                    ?.punched_time
                                                ) || "Pending"
                                              }
                                            />
                                          )}
                                        </Box>
                                      </Grid>
                                      {row.finishWorkTime?.punched_time &&
                                        row.finishWorkTime?.updated_by && (
                                          <Grid
                                            item
                                            lg={12}
                                            md={12}
                                            sm={12}
                                            xs={12}
                                            sx={{
                                              display: "flex",
                                              // justifyContent: "center",
                                            }}
                                          >
                                            <Typography
                                              sx={{
                                                fontStyle: "italic",
                                              }}
                                              color="textSecondary"
                                              variant="body2"
                                            >
                                              -- Edited --
                                            </Typography>
                                          </Grid>
                                        )}
                                    </Grid>
                                  </Grid>
                                </Grid>
                              </TableCell>

                              {hasActionsColumn &&
                                userHasRight(Privileges.ScheduleEdit) && (
                                  <TableCell className={classes.tablCell}>
                                    {row.workStartTime && (
                                      <Grid
                                        container
                                        spacing={1}
                                        alignItems="center"
                                        justifyContent="flex-end"
                                      >
                                        {row.finishWorkTime
                                          ?.isValidPunchRecord ===
                                          "notValiedRecord" && (
                                          <Grid item>
                                            <Typography
                                              sx={{
                                                color: "#d32f2f",
                                                fontWeight: 600,
                                                lineHeight: 1.5,
                                                fontSize: "0.875rem",
                                                fontStyle: "italic",
                                                whiteSpace: "nowrap",
                                              }}
                                            >
                                              Please check punch in/out times —
                                              invalid record.
                                            </Typography>
                                          </Grid>
                                        )}
                                        {row.workStartTime.id && (
                                          <Grid item>
                                            <Button
                                              className={
                                                classes.deleteButtonList
                                              }
                                              onClick={() =>
                                                handleOpenDialogAdminDelete(
                                                  String(
                                                    row.workStartTime?.id || ""
                                                  ),
                                                  teamMap.get(row.empid)
                                                    ?.name || "",
                                                  row
                                                )
                                              }
                                            >
                                              <DeleteOutlineSharpIcon
                                                className={
                                                  classes.deleteListIcon
                                                }
                                              />
                                            </Button>
                                          </Grid>
                                        )}
                                      </Grid>
                                    )}
                                  </TableCell>
                                )}
                            </TableRow>
                          ))
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Grid>
            </Card>
            {selectedCoursing && (
              <EmpImg
                openModel={openDialog}
                handleCloseDialog={handleCloseDialog}
                imgId={String(selectedCoursing.workStartTime?.id)}
              />
            )}
            {selectedImg && (
              <EmpImg
                openModel={openDialogImg}
                handleCloseDialog={handleCloseDialogImg}
                imgId={String(selectedImg?.finishWorkTime?.id)}
              />
            )}

            {selectedAdminEdit && selectedAdminEditStatus && (
              <AdminEdit
                openModel={openDialogAdminEdit}
                handleCloseDialog={handleCloseDialogAdminEdit}
                empid={Number(selectedAdminEdit.empid)}
                scheduleDate={paymentMonthYear.format("YYYY-MM-DD h:mm:ss A")}
                adminStatus={selectedAdminEditStatus}
              />
            )}

            {selectedAdminEditPunchIn && (
              <AdminPunchInEdit
                openModel={openDialogAdminEditPunchIn}
                handleCloseDialog={handleCloseDialogAdminEditPunchIn}
                id={Number(selectedAdminEditPunchIn.id)}
                scheduleDate={paymentMonthYear.format("YYYY-MM-DD h:mm:ss A")}
              />
            )}

            {selectedAdminEditPunchOut && (
              <AdminPunchOutEdit
                openModel={openDialogAdminEditPunchOut}
                handleCloseDialog={handleCloseDialogAdminEditPunchOut}
                id={Number(selectedAdminEditPunchOut.id)}
                scheduleDate={paymentMonthYear.format("YYYY-MM-DD h:mm:ss A")}
              />
            )}

            {openDialogAdminDelete &&
              selectedAdminDeleteId &&
              selectedAdminDeleteMessage &&
              selectedAdminDelete && (
                <AdminDeleteTimeSlote
                  openModel={openDialogAdminDelete}
                  handleCloseDialog={handleCloseDialogAdminDelete}
                  recordId={String(selectedAdminDeleteId)}
                  message={String(selectedAdminDeleteMessage)}
                  empid={Number(selectedAdminDelete.empid)}
                />
              )}

            <Dialog
              open={open}
              onClose={handleCloseDialogGenerate}
              sx={{ padding: 5, minWidth: 450 }}
            >
              <Grid
                className={isMobileRes ? classes.DialogMobile : classes.Dialog}
              >
                <Grid
                  container
                  justifyContent={"space-between"}
                  spacing={5}
                  sx={{ borderBottom: 2, padding: 2 }}
                  className={classes.titleGrid}
                >
                  <Grid
                    item
                    lg={12}
                    md={12}
                    sm={12}
                    xs={12}
                    pt={2}
                    alignContent={"center"}
                  >
                    <Typography className={classes.cardTitle}>
                      Confirm Action
                    </Typography>
                  </Grid>
                </Grid>
                <DialogContent>
                  <DialogContentText sx={{ pt: 3 }}>
                    Are you sure you want to generate the payroll? This action
                    cannot be undone.
                  </DialogContentText>
                </DialogContent>
                <DialogActions>
                  <Button
                    variant="outlined"
                    startIcon={<CloseIcon />}
                    className={classes.addButton}
                    onClick={handleCloseDialogGenerate}
                  >
                    Cancel
                  </Button>
                  <Box m={0.5}></Box>

                  <Button
                    onClick={handleConfirm}
                    variant="contained"
                    startIcon={<CheckCircleOutlineIcon />}
                    className={classes.addButton}
                  >
                    Confirm
                  </Button>
                </DialogActions>
              </Grid>
            </Dialog>
          </Grid>
        ) : (
          <Grid item lg={12} md={12} sm={12} xs={12}>
            <Card className={classes.card}>
              <Grid
                container
                justifyContent={"space-between"}
                spacing={5}
                sx={{ padding: 2 }}
                className={classes.titleGrid}
              >
                <Grid
                  item
                  lg={12}
                  md={12}
                  sm={12}
                  xs={12}
                  sx={{ display: "flex", justifyContent: "flex-end" }}
                >
                  <Grid
                    container
                    spacing={1}
                    justifyContent="flex-end"
                    sx={{
                      display: "flex",
                      justifyContent: {
                        xs: "flex-start",
                        md: "flex-end",
                      },
                    }}
                  >
                    <Grid item>
                      <List className={classes.ListPayroll}>
                        <ListItem className={classes.ListItemPayroll}>
                          <IconButton
                            color="primary"
                            onClick={goToPreviousDay}
                            aria-label="Previous Day"
                          >
                            <KeyboardArrowLeftIcon />
                          </IconButton>
                        </ListItem>
                        <ListItem className={classes.ListItemPayroll}>
                          <Button
                            className={classes.ListItemPayrollToday}
                            // onClick={goToToday}
                            aria-label="Today"
                          >
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                              <DatePicker
                                value={selectedDate}
                                onChange={handleDateChange}
                                slotProps={{
                                  textField: {
                                    placeholder: "Date of Birth",
                                    size: "small",
                                    sx: {
                                      width: "140px",
                                    },
                                    InputProps: {
                                      sx: {
                                        fontSize: 14,
                                        color: "#97c3df",
                                      },
                                      // classes: {
                                      //   // root: classes.textFieldQuote,
                                      // },
                                      classes: {
                                        root: classes.formControlListStatus,
                                        notchedOutline: classes.notchedOutline,
                                      },
                                    },
                                    InputLabelProps: {
                                      sx: {
                                        fontSize: 14,
                                        color: "#97c3df",
                                      },
                                    },
                                  },
                                }}
                              />
                            </LocalizationProvider>
                          </Button>
                        </ListItem>
                        <ListItem className={classes.ListItemPayroll}>
                          <IconButton
                            color="primary"
                            onClick={goToNextDay}
                            aria-label="Next Day"
                          >
                            <KeyboardArrowRightIcon />
                          </IconButton>
                        </ListItem>
                      </List>
                    </Grid>
                    <Grid item>
                      <Button
                        // variant="contained"
                        startIcon={<TableViewIcon />}
                        className={classes.addButtonPdfExcel}
                        onClick={handleExportToExcel}
                      >
                        Excel
                      </Button>
                    </Grid>
                    <Grid item>
                      <Button
                        // variant="contained"
                        startIcon={<LocalPrintshopSharpIcon />}
                        className={classes.addButtonPdfExcel}
                        onClick={handleExportToPDF}
                      >
                        pdf
                      </Button>
                    </Grid>
                    <Grid item>
                      <Link
                        to={`/attendance/create?date=${paymentMonthYear.format(
                          "YYYY-MM-DD"
                        )}`}
                        className={classes.iconLinkPropNormal}
                      >
                        <Button
                          // variant="contained"
                          className={classes.addNewButton}
                          onClick={handleAddProductClick}
                        >
                          Add New
                        </Button>
                      </Link>
                    </Grid>

                    {/* {userHasRight(Privileges.GeneratePayroll) && (
                    <Grid item>
                      <Button
                        className={classes.addButtonPdfExcel}
                        onClick={handleOpenDialogGenerate}
                      >
                        Generate Payroll
                      </Button>
                    </Grid>
                  )} */}
                  </Grid>
                </Grid>
              </Grid>

              <Grid>
                <TableContainer>
                  <Table className={classes.table}>
                    <TableHead className={classes.tableHeaderRow}>
                      <TableRow>
                        <TableCell className={classes.tablheader}>
                          <strong>Name</strong>
                        </TableCell>
                        <TableCell
                          className={classes.tablheader}
                          // sx={{ textAlign: "center" }}
                        >
                          <strong>Schedule</strong>
                        </TableCell>
                        <TableCell
                          className={classes.tablheader}
                          // sx={{ textAlign: "center" }}
                        >
                          <strong>clocked Hours</strong>
                        </TableCell>
                        <TableCell
                          className={classes.tablheader}
                          // sx={{ textAlign: "center" }}
                        >
                          <strong>Punch In</strong>
                        </TableCell>
                        <TableCell
                          className={classes.tablheader}
                          // sx={{ textAlign: "center" }}
                        >
                          <strong>Punch Out</strong>
                        </TableCell>
                        {hasActionsColumn &&
                          userHasRight(Privileges.ScheduleEdit) && (
                            <TableCell
                              className={classes.tablheader}
                              sx={{ textAlign: "right" }}
                            >
                              <strong>Actions</strong>
                            </TableCell>
                          )}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {isLoading || tenantIsLoading ? (
                        <TableRow>
                          <TableCell colSpan={20} align="center">
                            <Box display="flex" justifyContent="center" alignItems="center" height="10vh">
                      <StepUpSpinner size="medium" />
                    </Box>
                          </TableCell>
                        </TableRow>
                      ) : isError || coursings.length === 0 ? (
                        <TableRow>
                          <TableCell colSpan={20} align="center">
                            {isError
                              ? "Error fetching data"
                              : "No data available"}
                          </TableCell>
                        </TableRow>
                      ) : (
                        coursings
                          .slice(
                            page * rowsPerPage,
                            page * rowsPerPage + rowsPerPage
                          )
                          .map((row: IScheduleListDetails, index) => {
                            const customer = teamMap.get(row.empid);
                            return (
                              <>
                                <TableRow
                                  key={index}
                                  className={classes.tableRowHover}
                                >
                                  <TableCell
                                    component="th"
                                    scope="row"
                                    className={classes.tablCell}
                                  >
                                    <Link
                                      to={`/team-history/${row.empid}`}
                                      className={classes.iconLinkPropNormal}
                                    >
                                      <Grid container spacing={1}>
                                        {!isMobileRes && (
                                          <Grid item>
                                            {customer?.image ? (
                                              <Avatar
                                                alt="Img"
                                                src={customer.image}
                                                className={classes.avatatImage}
                                                sx={{
                                                  cursor: "pointer",
                                                }}
                                              />
                                            ) : (
                                              <Avatar
                                                className={classes.avatatImage}
                                              >
                                                {customer?.name ? (
                                                  `${customer?.name ?? ""}`
                                                    .trim()
                                                    .charAt(0)
                                                    .toUpperCase()
                                                ) : (
                                                  <GroupIcon />
                                                )}
                                              </Avatar>
                                            )}
                                          </Grid>
                                        )}
                                        <Grid
                                          item
                                          textAlign={"left"}
                                          alignContent={"center"}
                                        >
                                          <Typography
                                            className={classes.nameTableList}
                                          >
                                            {customer ? `${customer.name}` : ""}
                                          </Typography>
                                        </Grid>
                                      </Grid>
                                    </Link>
                                  </TableCell>
                                  <TableCell
                                    scope="row"
                                    className={classes.tablCell}
                                    // sx={{ textAlign: "center" }}
                                  >
                                    {formatTime(row.schedule?.startTime)} -{" "}
                                    {formatTime(row.schedule?.endTime)}{" "}
                                    {row.schedule &&
                                      row.schedule.spansNextDay == true && (
                                        <span
                                          style={{
                                            color: "#e3791a",
                                            fontWeight: 600,
                                            lineHeight: 1.5,
                                            fontSize: "0.875rem",
                                            paddingLeft: "1px",
                                          }}
                                        >
                                          [next day]
                                        </span>
                                      )}
                                    {row.schedule &&
                                    row.schedule.schedule_end_date ? (
                                      row.schedule.status === "deleted" ? (
                                        <span
                                          style={{
                                            color: "#d32f2f", // red
                                            fontWeight: 600,
                                            paddingLeft: "1px",
                                          }}
                                        >
                                          [D]
                                        </span>
                                      ) : row.schedule.schedule_end_date &&
                                        row.schedule.status === "updated" ? (
                                        <span
                                          style={{
                                            color: "#1976d2", // blue
                                            fontWeight: 600,
                                            paddingLeft: "1px",
                                          }}
                                        >
                                          [Up]
                                        </span>
                                      ) : null
                                    ) : null}
                                    {row.schedule &&
                                      row.schedule.total_scheduled_hours && (
                                        <span
                                          style={{
                                            color: "#28a745",
                                            fontWeight: 600,
                                            lineHeight: 1.5,
                                            fontSize: "0.875rem",
                                            paddingLeft: "1px",
                                          }}
                                        >
                                          {`(${row.schedule.total_scheduled_hours}h)`}
                                        </span>
                                      )}
                                  </TableCell>
                                  <TableCell
                                    scope="row"
                                    className={classes.tablCell}
                                    // sx={{ textAlign: "center" }}
                                  >
                                    <>
                                      {row.workStartTime
                                        ?.actual_punched_time ? (
                                        <>
                                          {formatTime(
                                            row.workStartTime
                                              .actual_punched_time
                                          )}{" "}
                                          -{" "}
                                          {row.finishWorkTime
                                            ?.actual_punched_time
                                            ? formatTime(
                                                row.finishWorkTime
                                                  .actual_punched_time
                                              )
                                            : "Pending"}
                                        </>
                                      ) : (
                                        <>
                                          {dayjs(paymentMonthYear).format(
                                            "YYYY-MM-DD"
                                          ) === dayjs().format("YYYY-MM-DD") &&
                                            row.schedule?.startTime &&
                                            (() => {
                                              const now = dayjs();
                                              const scheduleStart = dayjs(
                                                row.schedule.startTime,
                                                "HH:mm"
                                              );

                                              if (now.isAfter(scheduleStart)) {
                                                return (
                                                  <QuestionMarkIcon
                                                    className={
                                                      classes.badgePulse
                                                    }
                                                    sx={{
                                                      fontSize: 22,
                                                      color: "error.main",
                                                      borderRadius: "50%",
                                                    }}
                                                  />
                                                );
                                              }

                                              return null;
                                            })()}
                                        </>
                                      )}
                                      <br />
                                      {row.workStartTime && (
                                        <>
                                          {Array.isArray(
                                            row.workStartTime.fristBreak
                                          ) &&
                                            row.workStartTime.fristBreak.map(
                                              (
                                                time: string | [string, string],
                                                index: number
                                              ) => {
                                                let punchOut:
                                                  | string
                                                  | undefined;
                                                let punchIn: string | undefined;

                                                // Support both ["out", "in"] or just ["out"]
                                                if (Array.isArray(time)) {
                                                  [punchOut, punchIn] = time;
                                                } else {
                                                  punchOut = time;
                                                  punchIn = undefined;
                                                }

                                                const punchDate = dayjs(
                                                  row.workStartTime
                                                    ?.punched_date
                                                );
                                                const breakOut = punchOut
                                                  ? dayjs(punchOut)
                                                  : null;
                                                const breakIn = punchIn
                                                  ? dayjs(punchIn)
                                                  : null;

                                                const formatBreak = (
                                                  t: Dayjs | null
                                                ) =>
                                                  !t || !t.isValid()
                                                    ? "Pending"
                                                    : (t.isSame(
                                                        punchDate,
                                                        "day"
                                                      )
                                                        ? t.format("h:mm a")
                                                        : t.format(
                                                            "MMM D, h:mm a"
                                                          )
                                                      )
                                                        .replace("am", "a.m.")
                                                        .replace("pm", "p.m.");
                                                const isPaidBreak =
                                                  parseFloat(
                                                    (
                                                      row.workStartTime
                                                        ?.fristbreakhour ?? "0"
                                                    ).toString()
                                                  ) > 0;

                                                return (
                                                  <Typography
                                                    key={`break1-${index}`}
                                                    sx={{
                                                      // color:"#007f00",
                                                      fontWeight: 600,
                                                      lineHeight: 1.5,
                                                      fontSize: "0.875rem",
                                                      paddingLeft: "1px",
                                                      // fontStyle: "italic",
                                                      marginTop: 0.5,
                                                    }}
                                                    color="textSecondary"
                                                  >
                                                    Break 1:{" "}
                                                    {formatBreak(breakOut)} -{" "}
                                                    {formatBreak(breakIn)}
                                                    {breakOut &&
                                                      breakIn &&
                                                      isPaidBreak && (
                                                        <strong
                                                          style={{
                                                            color: "#007f00",
                                                          }}
                                                        >{` [PB]`}</strong>
                                                      )}
                                                  </Typography>
                                                );
                                              }
                                            )}

                                          {/* Break 2 */}
                                          {Array.isArray(
                                            row.workStartTime.secoundBreak
                                          ) &&
                                            row.workStartTime.secoundBreak.map(
                                              (
                                                time: string | [string, string],
                                                index: number
                                              ) => {
                                                let punchOut:
                                                  | string
                                                  | undefined;
                                                let punchIn: string | undefined;

                                                // Support both ["out", "in"] or just ["out"]
                                                if (Array.isArray(time)) {
                                                  [punchOut, punchIn] = time;
                                                } else {
                                                  punchOut = time;
                                                  punchIn = undefined;
                                                }

                                                const punchDate = dayjs(
                                                  row.workStartTime
                                                    ?.punched_date
                                                );
                                                const breakOut = punchOut
                                                  ? dayjs(punchOut)
                                                  : null;
                                                const breakIn = punchIn
                                                  ? dayjs(punchIn)
                                                  : null;

                                                const formatBreak = (
                                                  t: Dayjs | null
                                                ) =>
                                                  !t || !t.isValid()
                                                    ? "Pending"
                                                    : (t.isSame(
                                                        punchDate,
                                                        "day"
                                                      )
                                                        ? t.format("h:mm a")
                                                        : t.format(
                                                            "MMM D, h:mm a"
                                                          )
                                                      )
                                                        .replace("am", "a.m.")
                                                        .replace("pm", "p.m.");
                                                const isPaidBreak =
                                                  parseFloat(
                                                    (
                                                      row.workStartTime
                                                        ?.secoundbreakhour ??
                                                      "0"
                                                    ).toString()
                                                  ) > 0;

                                                return (
                                                  <Typography
                                                    key={`break1-${index}`}
                                                    sx={{
                                                      // color:"#007f00",
                                                      fontWeight: 600,
                                                      lineHeight: 1.5,
                                                      fontSize: "0.875rem",
                                                      paddingLeft: "1px",
                                                      // fontStyle: "italic",
                                                      marginTop: 0.5,
                                                    }}
                                                    color="textSecondary"
                                                  >
                                                    Break 2:{" "}
                                                    {formatBreak(breakOut)} -{" "}
                                                    {formatBreak(breakIn)}
                                                    {breakOut &&
                                                      breakIn &&
                                                      isPaidBreak && (
                                                        <strong
                                                          style={{
                                                            color: "#007f00",
                                                          }}
                                                        >{` [PB]`}</strong>
                                                      )}
                                                  </Typography>
                                                );
                                              }
                                            )}
                                        </>
                                      )}
                                    </>
                                  </TableCell>
                                  <TableCell
                                    scope="row"
                                    className={classes.tablCell}
                                    // sx={{ textAlign: "center" }}
                                  >
                                    <Grid
                                      container
                                      spacing={1}
                                      // justifyContent={"center"}
                                    >
                                      <Grid
                                        item
                                        lg={12}
                                        md={12}
                                        sm={12}
                                        xs={12}
                                        sx={{
                                          display: "flex",
                                          // justifyContent: "center",
                                        }}
                                      >
                                        <Box
                                          // className={
                                          //   row.isStartWork === false
                                          //     ? classes.editButtonStatusWaiting
                                          //     : classes.editButtonStatusAvailable
                                          // }
                                          sx={{
                                            cursor: row.workStartTime
                                              ?.punched_time
                                              ? "pointer"
                                              : "pointer",
                                          }}
                                          onClick={() => {
                                            if (
                                              row.workStartTime?.punched_time &&
                                              userHasRight(
                                                Privileges.ScheduleEdit
                                              )
                                            ) {
                                              handleOpenDialogAdminEditPunchIn(
                                                row.workStartTime
                                              );
                                            } else {
                                              handleOpenDialogAdminEdit(
                                                row,
                                                "punch_in"
                                              );
                                            }
                                          }}
                                        >
                                          {userHasRight(
                                            Privileges.ScheduleEdit
                                          ) &&
                                          row.workStartTime?.punched_time ? (
                                            <>
                                              <Tooltip
                                                title={
                                                  <Box
                                                    sx={{ p: 1, maxWidth: 300 }}
                                                  >
                                                    {row.workStartTime
                                                      ?.punchInHistory?.length >
                                                      0 && (
                                                      <Typography
                                                        variant="body2"
                                                        sx={{
                                                          fontWeight: 600,
                                                          mb: 1,
                                                        }}
                                                      >
                                                        Punch-in Edit History
                                                      </Typography>
                                                    )}

                                                    {row.workStartTime
                                                      ?.punchInHistory?.length >
                                                    0 ? (
                                                      row.workStartTime.punchInHistory.map(
                                                        (history) => (
                                                          <Box
                                                            key={history.id}
                                                            sx={{
                                                              mb: 1,
                                                              p: 1,
                                                              borderRadius: 1,
                                                              backgroundColor:
                                                                "#f9f9f9",
                                                              border:
                                                                "1px solid #e0e0e0",
                                                            }}
                                                          >
                                                            <Typography
                                                              variant="body2"
                                                              className={
                                                                classes.tooltipTypograpy
                                                              }
                                                            >
                                                              <strong>
                                                                Date:
                                                              </strong>{" "}
                                                              {dayjs(
                                                                history.date
                                                              ).format(
                                                                "MMM DD, YYYY"
                                                              )}
                                                            </Typography>
                                                            {history.time && (
                                                              <Typography
                                                                variant="body2"
                                                                className={
                                                                  classes.tooltipTypograpy
                                                                }
                                                              >
                                                                <strong>
                                                                  Time:
                                                                </strong>{" "}
                                                                {/* {dayjs(
                                                                history.time,
                                                                "HH:mm:ss"
                                                              ).format(
                                                                "hh:mm A"
                                                              )} */}
                                                                {formatTime(
                                                                  history.time
                                                                )}
                                                              </Typography>
                                                            )}
                                                            {history.status ===
                                                              "Created" && (
                                                              <Typography
                                                                variant="body2"
                                                                className={
                                                                  classes.tooltipTypograpy
                                                                }
                                                              >
                                                                <strong>
                                                                  Method:
                                                                </strong>{" "}
                                                                {history.isFacialPunch
                                                                  ? "Facial"
                                                                  : "Fingerprint"}
                                                              </Typography>
                                                            )}
                                                            {history.status ===
                                                              "AdminCreatedInLocal" && (
                                                              <Typography
                                                                variant="body2"
                                                                className={
                                                                  classes.tooltipTypograpy
                                                                }
                                                              >
                                                                <strong>
                                                                  Method:
                                                                </strong>{" "}
                                                                {history.isFacialPunch
                                                                  ? "Facial Local Admin"
                                                                  : "Fingerprint Local Admin"}
                                                              </Typography>
                                                            )}
                                                            {history.reason && (
                                                              <Typography
                                                                variant="body2"
                                                                className={
                                                                  classes.tooltipTypograpy
                                                                }
                                                              >
                                                                <strong>
                                                                  Reason:
                                                                </strong>{" "}
                                                                {history.reason}
                                                              </Typography>
                                                            )}
                                                            {history.created_by && (
                                                              <Typography
                                                                variant="body2"
                                                                className={
                                                                  classes.tooltipTypograpy
                                                                }
                                                              >
                                                                <strong>
                                                                  Updated By:
                                                                </strong>{" "}
                                                                {userMap.get(
                                                                  history.created_by
                                                                ) || ""}
                                                              </Typography>
                                                            )}
                                                            <Typography
                                                              variant="body2"
                                                              className={
                                                                classes.tooltipTypograpy
                                                              }
                                                            >
                                                              <strong>
                                                                Updated At:
                                                              </strong>{" "}
                                                              {dayjs(
                                                                history.created_at
                                                              ).format(
                                                                "MMM DD, YYYY hh:mm A"
                                                              )}
                                                            </Typography>
                                                            {history.emp_image && (
                                                              <Typography
                                                                variant="body2"
                                                                className={
                                                                  classes.tooltipTypograpy
                                                                }
                                                              >
                                                                <strong>
                                                                  Image:
                                                                </strong>{" "}
                                                                <a
                                                                  href={
                                                                    history.emp_image
                                                                  }
                                                                  target="_blank"
                                                                  rel="noopener noreferrer"
                                                                  style={{
                                                                    color:
                                                                      "#1976d2",
                                                                    textDecoration:
                                                                      "underline",
                                                                  }}
                                                                >
                                                                  View Image
                                                                </a>
                                                              </Typography>
                                                            )}
                                                          </Box>
                                                        )
                                                      )
                                                    ) : (
                                                      <Typography
                                                        variant="body2"
                                                        sx={{
                                                          fontWeight: 600,
                                                          mb: 1,
                                                        }}
                                                      >
                                                        Edit Punch-in
                                                      </Typography>
                                                    )}
                                                  </Box>
                                                }
                                                sx={{ fontSize: "14px" }}
                                              >
                                                <Chip
                                                  sx={{
                                                    cursor: row.workStartTime
                                                      ?.punched_time
                                                      ? "pointer"
                                                      : "pointer",
                                                  }}
                                                  className={
                                                    row.isStartWork === false
                                                      ? classes.editChipWorkFalse
                                                      : classes.editChipWorkTrue
                                                  }
                                                  label={
                                                    <>
                                                      {formatTime(
                                                        row.workStartTime
                                                          .punched_time
                                                      ) || "Pending"}
                                                      <CiEdit
                                                        style={{
                                                          fontSize: 20,
                                                          marginLeft: "5px",
                                                        }}
                                                      />
                                                    </>
                                                  }
                                                />
                                              </Tooltip>
                                            </>
                                          ) : (
                                            <Chip
                                              sx={{
                                                cursor: row.workStartTime
                                                  ?.punched_time
                                                  ? "pointer"
                                                  : "pointer",
                                              }}
                                              className={
                                                row.isFinishWork === false
                                                  ? classes.editChipWorkFalse
                                                  : classes.editChipWorkTrue
                                              }
                                              label={
                                                formatTime(
                                                  row.workStartTime
                                                    ?.punched_time
                                                ) || "Pending"
                                              }
                                            />
                                          )}
                                        </Box>
                                      </Grid>
                                      {row.workStartTime?.punched_time &&
                                        row.workStartTime?.created_by && (
                                          <Grid
                                            item
                                            lg={12}
                                            md={12}
                                            sm={12}
                                            xs={12}
                                            // sx={{
                                            //   display: "flex",
                                            //   justifyContent: "center",
                                            // }}
                                          >
                                            <Typography
                                              sx={{
                                                fontStyle: "italic",
                                              }}
                                              color="textSecondary"
                                              variant="body2"
                                            >
                                              -- Edited --
                                            </Typography>
                                          </Grid>
                                        )}
                                    </Grid>
                                  </TableCell>

                                  <TableCell
                                    scope="row"
                                    className={classes.tablCell}
                                    // sx={{ textAlign: "center" }}
                                  >
                                    <Grid
                                      container
                                      spacing={1}
                                      // justifyContent={"center"}
                                    >
                                      <Grid
                                        item
                                        lg={12}
                                        md={12}
                                        sm={12}
                                        xs={12}
                                        sx={{
                                          display: "flex",
                                          // justifyContent: "center",
                                        }}
                                      >
                                        <Box
                                          // className={
                                          //   row.isFinishWork === false
                                          //     ? classes.editButtonStatusWaiting
                                          //     : classes.editButtonStatusAvailable
                                          // }
                                          sx={{
                                            cursor: row.finishWorkTime
                                              ?.punched_time
                                              ? "pointer"
                                              : "pointer",
                                          }}
                                          onClick={() => {
                                            if (
                                              row.finishWorkTime
                                                ?.punched_time &&
                                              userHasRight(
                                                Privileges.ScheduleEdit
                                              )
                                            ) {
                                              handleOpenDialogAdminEditPunchOut(
                                                row.finishWorkTime
                                              );
                                            } else if (
                                              row.workStartTime?.punched_time &&
                                              userHasRight(
                                                Privileges.ScheduleEdit
                                              )
                                            ) {
                                              handleOpenDialogAdminEdit(
                                                row,
                                                "punch_out"
                                              );
                                            }
                                          }}
                                        >
                                          {userHasRight(
                                            Privileges.ScheduleEdit
                                          ) &&
                                          row.finishWorkTime?.punched_time ? (
                                            <Tooltip
                                              title={
                                                <Box
                                                  sx={{ p: 1, maxWidth: 300 }}
                                                >
                                                  {row.finishWorkTime
                                                    ?.punchOutHistory?.length >
                                                    0 && (
                                                    <Typography
                                                      variant="body2"
                                                      sx={{
                                                        fontWeight: 600,
                                                        mb: 1,
                                                      }}
                                                    >
                                                      Punch-out Edit History
                                                    </Typography>
                                                  )}

                                                  {row.finishWorkTime
                                                    ?.punchOutHistory?.length >
                                                  0 ? (
                                                    row.finishWorkTime.punchOutHistory.map(
                                                      (history) => (
                                                        <Box
                                                          key={history.id}
                                                          sx={{
                                                            mb: 1,
                                                            p: 1,
                                                            borderRadius: 1,
                                                            backgroundColor:
                                                              "#f9f9f9",
                                                            border:
                                                              "1px solid #e0e0e0",
                                                          }}
                                                        >
                                                          <Typography
                                                            variant="body2"
                                                            className={
                                                              classes.tooltipTypograpy
                                                            }
                                                          >
                                                            <strong>
                                                              Date:
                                                            </strong>{" "}
                                                            {dayjs(
                                                              history.date
                                                            ).format(
                                                              "MMM DD, YYYY"
                                                            )}
                                                          </Typography>
                                                          {history.time && (
                                                            <Typography
                                                              variant="body2"
                                                              className={
                                                                classes.tooltipTypograpy
                                                              }
                                                            >
                                                              <strong>
                                                                Time:
                                                              </strong>{" "}
                                                              {formatTime(
                                                                history.time
                                                              )}
                                                            </Typography>
                                                          )}
                                                          {history.status ===
                                                            "Created" && (
                                                            <Typography
                                                              variant="body2"
                                                              className={
                                                                classes.tooltipTypograpy
                                                              }
                                                            >
                                                              <strong>
                                                                Method:
                                                              </strong>{" "}
                                                              {history.isFacialPunch
                                                                ? "Facial"
                                                                : "Fingerprint"}
                                                            </Typography>
                                                          )}
                                                          {history.status ===
                                                            "AdminCreatedInLocal" && (
                                                            <Typography
                                                              variant="body2"
                                                              className={
                                                                classes.tooltipTypograpy
                                                              }
                                                            >
                                                              <strong>
                                                                Method:
                                                              </strong>{" "}
                                                              {history.isFacialPunch
                                                                ? "Facial Local Admin"
                                                                : "Fingerprint Local Admin"}
                                                            </Typography>
                                                          )}
                                                          {history.reason && (
                                                            <Typography
                                                              variant="body2"
                                                              className={
                                                                classes.tooltipTypograpy
                                                              }
                                                            >
                                                              <strong>
                                                                Reason:
                                                              </strong>{" "}
                                                              {history.reason}
                                                            </Typography>
                                                          )}
                                                          {history.created_by && (
                                                            <Typography
                                                              variant="body2"
                                                              className={
                                                                classes.tooltipTypograpy
                                                              }
                                                            >
                                                              <strong>
                                                                Updated By:
                                                              </strong>{" "}
                                                              {userMap.get(
                                                                history.created_by
                                                              ) || ""}
                                                            </Typography>
                                                          )}
                                                          <Typography
                                                            variant="body2"
                                                            className={
                                                              classes.tooltipTypograpy
                                                            }
                                                          >
                                                            <strong>
                                                              Updated At:
                                                            </strong>{" "}
                                                            {dayjs(
                                                              history.created_at
                                                            ).format(
                                                              "MMM DD, YYYY hh:mm A"
                                                            )}
                                                          </Typography>
                                                          {history.emp_image && (
                                                            <Typography
                                                              variant="body2"
                                                              className={
                                                                classes.tooltipTypograpy
                                                              }
                                                            >
                                                              <strong>
                                                                Image:
                                                              </strong>{" "}
                                                              <a
                                                                href={
                                                                  history.emp_image
                                                                }
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                                style={{
                                                                  color:
                                                                    "#1976d2",
                                                                  textDecoration:
                                                                    "underline",
                                                                }}
                                                              >
                                                                View Image
                                                              </a>
                                                            </Typography>
                                                          )}
                                                        </Box>
                                                      )
                                                    )
                                                  ) : (
                                                    <Typography
                                                      variant="body2"
                                                      sx={{
                                                        fontWeight: 600,
                                                        mb: 1,
                                                      }}
                                                    >
                                                      Edit Punch-out
                                                    </Typography>
                                                  )}
                                                </Box>
                                              }
                                              sx={{ fontSize: "14px" }}
                                            >
                                              <Chip
                                                sx={{
                                                  cursor: row.finishWorkTime
                                                    ?.punched_time
                                                    ? "pointer"
                                                    : "pointer",
                                                }}
                                                className={
                                                  row.isFinishWork === false
                                                    ? classes.editChipWorkFalse
                                                    : classes.editChipWorkTrue
                                                }
                                                label={
                                                  <>
                                                    {row.workStartTime
                                                      ?.punched_date !==
                                                    row.finishWorkTime
                                                      .punched_date
                                                      ? `${dayjs(
                                                          row.finishWorkTime
                                                            .punched_date
                                                        ).format(
                                                          "MMM-DD, YYYY"
                                                        )} ${formatTime(
                                                          row.finishWorkTime
                                                            .punched_time
                                                        )}`
                                                      : formatTime(
                                                          row.finishWorkTime
                                                            .punched_time
                                                        ) || "Pending"}
                                                    <CiEdit
                                                      style={{
                                                        fontSize: 20,
                                                        marginLeft: "5px",
                                                      }}
                                                    />
                                                  </>
                                                }
                                              />
                                            </Tooltip>
                                          ) : (
                                            <Chip
                                              sx={{
                                                cursor:
                                                  row.finishWorkTime
                                                    ?.punched_time ||
                                                  row.workStartTime
                                                    ?.punched_time
                                                    ? "pointer"
                                                    : "default",
                                              }}
                                              className={
                                                row.isFinishWork === false
                                                  ? classes.editChipWorkFalse
                                                  : classes.editChipWorkTrue
                                              }
                                              label={
                                                formatTime(
                                                  row.finishWorkTime
                                                    ?.punched_time
                                                ) || "Pending"
                                              }
                                            />
                                          )}
                                        </Box>
                                      </Grid>
                                      {row.finishWorkTime?.punched_time &&
                                        row.finishWorkTime?.updated_by && (
                                          <Grid
                                            item
                                            lg={12}
                                            md={12}
                                            sm={12}
                                            xs={12}
                                            // sx={{
                                            //   display: "flex",
                                            //   justifyContent: "center",
                                            // }}
                                          >
                                            <Typography
                                              sx={{
                                                fontStyle: "italic",
                                              }}
                                              color="textSecondary"
                                              variant="body2"
                                            >
                                              -- Edited --
                                            </Typography>
                                          </Grid>
                                        )}
                                    </Grid>
                                  </TableCell>
                                  {hasActionsColumn &&
                                    userHasRight(Privileges.ScheduleEdit) && (
                                      <TableCell className={classes.tablCell}>
                                        {row.workStartTime && (
                                          <Grid
                                            container
                                            spacing={1}
                                            alignItems="center"
                                            justifyContent="flex-end"
                                          >
                                            {row.finishWorkTime
                                              ?.isValidPunchRecord ===
                                              "notValiedRecord" && (
                                              <Grid item>
                                                <Typography
                                                  sx={{
                                                    color: "#d32f2f",
                                                    fontWeight: 600,
                                                    lineHeight: 1.5,
                                                    fontSize: "0.875rem",
                                                    fontStyle: "italic",
                                                    whiteSpace: "nowrap",
                                                  }}
                                                >
                                                  Please check punch in/out
                                                  times — invalid record.
                                                </Typography>
                                              </Grid>
                                            )}
                                            {row.workStartTime.id && (
                                              <Grid item>
                                                <Button
                                                  className={
                                                    classes.deleteButtonList
                                                  }
                                                  onClick={() =>
                                                    handleOpenDialogAdminDelete(
                                                      String(
                                                        row.workStartTime?.id ||
                                                          ""
                                                      ),
                                                      teamMap.get(row.empid)
                                                        ?.name || "",
                                                      row
                                                    )
                                                  }
                                                >
                                                  <DeleteOutlineSharpIcon
                                                    className={
                                                      classes.deleteListIcon
                                                    }
                                                  />
                                                </Button>
                                              </Grid>
                                            )}
                                          </Grid>
                                        )}
                                      </TableCell>
                                    )}
                                </TableRow>
                              </>
                            );
                          })
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Grid>
            </Card>
            {selectedCoursing && (
              <EmpImg
                openModel={openDialog}
                handleCloseDialog={handleCloseDialog}
                imgId={String(selectedCoursing.workStartTime?.id)}
              />
            )}
            {selectedImg && (
              <EmpImg
                openModel={openDialogImg}
                handleCloseDialog={handleCloseDialogImg}
                imgId={String(selectedImg?.finishWorkTime?.id)}
              />
            )}

            {selectedAdminEdit && selectedAdminEditStatus && (
              <AdminEdit
                openModel={openDialogAdminEdit}
                handleCloseDialog={handleCloseDialogAdminEdit}
                empid={Number(selectedAdminEdit.empid)}
                scheduleDate={paymentMonthYear.format("YYYY-MM-DD h:mm:ss A")}
                adminStatus={selectedAdminEditStatus}
              />
            )}

            {selectedAdminEditPunchIn && (
              <AdminPunchInEdit
                openModel={openDialogAdminEditPunchIn}
                handleCloseDialog={handleCloseDialogAdminEditPunchIn}
                id={Number(selectedAdminEditPunchIn.id)}
                scheduleDate={paymentMonthYear.format("YYYY-MM-DD h:mm:ss A")}
              />
            )}

            {selectedAdminEditPunchOut && (
              <AdminPunchOutEdit
                openModel={openDialogAdminEditPunchOut}
                handleCloseDialog={handleCloseDialogAdminEditPunchOut}
                id={Number(selectedAdminEditPunchOut.id)}
                scheduleDate={paymentMonthYear.format("YYYY-MM-DD h:mm:ss A")}
              />
            )}

            {openDialogAdminDelete &&
              selectedAdminDeleteId &&
              selectedAdminDeleteMessage &&
              selectedAdminDelete && (
                <AdminDeleteTimeSlote
                  openModel={openDialogAdminDelete}
                  handleCloseDialog={handleCloseDialogAdminDelete}
                  recordId={String(selectedAdminDeleteId)}
                  message={String(selectedAdminDeleteMessage)}
                  empid={Number(selectedAdminDelete.empid)}
                />
              )}

            <Dialog
              open={open}
              onClose={handleCloseDialogGenerate}
              sx={{ padding: 5, minWidth: 450 }}
            >
              <Grid
                className={isMobileRes ? classes.DialogMobile : classes.Dialog}
              >
                <Grid
                  container
                  justifyContent={"space-between"}
                  spacing={5}
                  sx={{ borderBottom: 2, padding: 2 }}
                  className={classes.titleGrid}
                >
                  <Grid
                    item
                    lg={12}
                    md={12}
                    sm={12}
                    xs={12}
                    pt={2}
                    alignContent={"center"}
                  >
                    <Typography className={classes.cardTitle}>
                      Confirm Action
                    </Typography>
                  </Grid>
                </Grid>
                <DialogContent>
                  <DialogContentText sx={{ pt: 3 }}>
                    Are you sure you want to generate the payroll? This action
                    cannot be undone.
                  </DialogContentText>
                </DialogContent>
                <DialogActions>
                  <Button
                    variant="outlined"
                    startIcon={<CloseIcon />}
                    className={classes.addButton}
                    onClick={handleCloseDialogGenerate}
                  >
                    Cancel
                  </Button>
                  <Box m={0.5}></Box>

                  <Button
                    onClick={handleConfirm}
                    variant="contained"
                    startIcon={<CheckCircleOutlineIcon />}
                    className={classes.addButton}
                  >
                    Confirm
                  </Button>
                </DialogActions>
              </Grid>
            </Dialog>
          </Grid>
        )}

        {isMobileRes && deleteRecords.length > 0 && !deleteRecordIsError ? (
          <Grid item lg={12} md={12} sm={12} xs={12}>
            <Card className={classes.card}>
              <Grid
                container
                justifyContent={"space-between"}
                spacing={2}
                sx={{ borderBottom: 2, padding: 2 }}
                className={classes.titleGrid}
              >
                <Grid
                  item
                  lg={12}
                  md={12}
                  sm={12}
                  xs={12}
                  sx={{ display: "flex", justifyContent: "flex-start" }}
                >
                  <Grid
                    container
                    spacing={1}
                    justifyContent="flex-start"
                    sx={{
                      display: "flex",
                      justifyContent: {
                        xs: "flex-start",
                        md: "flex-start",
                      },
                    }}
                  >
                    <Grid item>
                      <Grid item>
                        <Typography
                          sx={{
                            color: "#d32f2f",
                            fontWeight: 600,
                            lineHeight: 1.5,
                            fontSize: "16px",
                            // fontStyle: "italic",
                            whiteSpace: "nowrap",
                          }}
                        >
                          Deleted Records
                        </Typography>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>

              <Grid>
                <TableContainer>
                  <Table className={classes.table}>
                    <TableHead className={classes.tableHeaderRow}>
                      <TableRow>
                        <TableCell className={classes.tablheader}>
                          <strong>Name</strong>
                        </TableCell>
                        <TableCell
                          className={classes.tablheader}
                          // sx={{ textAlign: "center" }}
                        >
                          <strong>clocked Hours</strong>
                        </TableCell>
                        <TableCell
                          className={classes.tablheader}
                          // sx={{ textAlign: "center" }}
                        >
                          <strong>Punch In</strong>
                        </TableCell>
                        <TableCell
                          className={classes.tablheader}
                          // sx={{ textAlign: "center" }}
                        >
                          <strong>Punch Out</strong>
                        </TableCell>
                        <TableCell
                          className={classes.tablheader}
                          sx={{ textAlign: "right" }}
                        >
                          <strong>Reason</strong>
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {deleteRecordIsLoadig || tenantIsLoading ? (
                        <TableRow>
                          <TableCell colSpan={20} align="center">
                            <Box display="flex" justifyContent="center" alignItems="center" height="10vh">
                      <StepUpSpinner size="medium" />
                    </Box>
                          </TableCell>
                        </TableRow>
                      ) : deleteRecordIsError || deleteRecords.length === 0 ? (
                        <TableRow>
                          <TableCell colSpan={20} align="center">
                            {deleteRecordIsError
                              ? "Error fetching data"
                              : "No data available"}
                          </TableCell>
                        </TableRow>
                      ) : (
                        deleteRecords.map(
                          (row: IScheduleListDetails, index) => (
                            <TableRow
                              key={index}
                              className={classes.tableRowHover}
                              // sx={{
                              //   backgroundColor:
                              //     !row.workStartTime?.punched_time &&
                              //     row.schedule?.startTime &&
                              //     dayjs(
                              //       `2000-01-01T${row.schedule?.startTime}`
                              //     ).isBefore(
                              //       dayjs(`2000-01-01T${dayjs().format("HH:mm")}`)
                              //     )
                              //       ? "#f5e5e5c4"
                              //       : "transparent",
                              // }}

                              sx={{
                                backgroundColor:
                                  row.finishWorkTime?.isValidPunchRecord ===
                                  "notValiedRecord"
                                    ? "transparent" // treat invalid as valid - no red background or error style
                                    : undefined, // default styles for other statuses
                              }}
                            >
                              <TableCell
                                component="th"
                                scope="row"
                                className={classes.tablCell}
                              >
                                {" "}
                                <Grid container spacing={1}>
                                  {/* <Grid item>
                                <Box className={classes.SelectImageTableBox}>
                                  {teamMap.get(row.empid)?.image ? (
                                    <img
                                      src={teamMap.get(row.empid)?.image}
                                      alt="Category Image"
                                      className={classes.SelectImageTable}
                                    />
                                  ) : (
                                    <Avatar
                                      alt="Travis Howard"
                                      src={AvatarImg}
                                      className={classes.SelectImageTable}
                                    />
                                  )}
                                </Box>
                              </Grid> */}
                                  <Grid item>
                                    <Link
                                      to={`/team-history/${row.empid}`}
                                      className={classes.iconLinkPropNormal}
                                    >
                                      <Typography
                                        className={classes.nameTableList}
                                      >
                                        {teamMap.get(row.empid)?.name || ""}
                                        {/* <span
                                          style={{
                                            cursor: "pointer",
                                            display: "inline-flex",
                                            alignItems: "center",
                                            paddingLeft: "5px",
                                          }}
                                        >
                                          <FontAwesomeIcon
                                            icon={faUser}
                                            style={{ color: "#1976d2" }}
                                          />
                                        </span> */}
                                      </Typography>
                                    </Link>
                                    <Typography
                                      className={classes.mobileListText}
                                    >
                                      {formatTime(row.schedule?.startTime)} -{" "}
                                      {formatTime(row.schedule?.endTime)}{" "}
                                      {row.schedule &&
                                        row.schedule.spansNextDay == true && (
                                          <span
                                            style={{
                                              color: "#e3791a",
                                              fontWeight: 600,
                                              // lineHeight: 1.5,
                                              // fontSize: "0.875rem",
                                              paddingLeft: "1px",
                                            }}
                                          >
                                            [next day]
                                          </span>
                                        )}
                                      {row.schedule &&
                                      row.schedule.schedule_end_date ? (
                                        row.schedule.status === "deleted" ? (
                                          <span
                                            style={{
                                              color: "#d32f2f", // red
                                              fontWeight: 600,
                                              paddingLeft: "1px",
                                            }}
                                          >
                                            [D]
                                          </span>
                                        ) : row.schedule.schedule_end_date &&
                                          row.schedule.status === "updated" ? (
                                          <span
                                            style={{
                                              color: "#1976d2",
                                              fontWeight: 600,
                                              paddingLeft: "1px",
                                            }}
                                          >
                                            [Up]
                                          </span>
                                        ) : null
                                      ) : null}
                                      {row.schedule &&
                                        row.schedule.total_scheduled_hours && (
                                          <span
                                            style={{
                                              color: "#28a745",
                                              fontWeight: 600,
                                              paddingLeft: "1px",
                                            }}
                                          >
                                            {`(${row.schedule.total_scheduled_hours}h)`}
                                          </span>
                                        )}
                                    </Typography>
                                  </Grid>
                                </Grid>
                              </TableCell>

                              <TableCell
                                scope="row"
                                className={classes.tablCell}
                                // sx={{ textAlign: "center" }}
                              >
                                <>
                                  {row.workStartTime?.actual_punched_time ? (
                                    <>
                                      {formatTime(
                                        row.workStartTime.actual_punched_time
                                      )}{" "}
                                      -{" "}
                                      {row.finishWorkTime?.actual_punched_time
                                        ? formatTime(
                                            row.finishWorkTime
                                              .actual_punched_time
                                          )
                                        : "Pending"}
                                    </>
                                  ) : (
                                    ""
                                  )}
                                  <br />
                                  {row.workStartTime && (
                                    <>
                                      {Array.isArray(
                                        row.workStartTime.fristBreak
                                      ) &&
                                        row.workStartTime.fristBreak.map(
                                          (
                                            time: string | [string, string],
                                            index: number
                                          ) => {
                                            let punchOut: string | undefined;
                                            let punchIn: string | undefined;

                                            // Support both ["out", "in"] or just ["out"]
                                            if (Array.isArray(time)) {
                                              [punchOut, punchIn] = time;
                                            } else {
                                              punchOut = time;
                                              punchIn = undefined;
                                            }

                                            const punchDate = dayjs(
                                              row.workStartTime?.punched_date
                                            );
                                            const breakOut = punchOut
                                              ? dayjs(punchOut)
                                              : null;
                                            const breakIn = punchIn
                                              ? dayjs(punchIn)
                                              : null;

                                            const formatBreak = (
                                              t: Dayjs | null
                                            ) =>
                                              !t || !t.isValid()
                                                ? "Pending"
                                                : (t.isSame(punchDate, "day")
                                                    ? t.format("h:mm a")
                                                    : t.format("MMM D, h:mm a")
                                                  )
                                                    .replace("am", "a.m.")
                                                    .replace("pm", "p.m.");
                                            const isPaidBreak =
                                              parseFloat(
                                                (
                                                  row.workStartTime
                                                    ?.fristbreakhour ?? "0"
                                                ).toString()
                                              ) > 0;

                                            return (
                                              <Typography
                                                key={`break1-${index}`}
                                                sx={{
                                                  // color:"#007f00",
                                                  fontWeight: 600,
                                                  lineHeight: 1.5,
                                                  fontSize: "0.875rem",
                                                  paddingLeft: "1px",
                                                  // fontStyle: "italic",
                                                  marginTop: 0.5,
                                                }}
                                                color="textSecondary"
                                              >
                                                Break 1: {formatBreak(breakOut)}{" "}
                                                - {formatBreak(breakIn)}
                                                {breakOut &&
                                                  breakIn &&
                                                  isPaidBreak && (
                                                    <strong
                                                      style={{
                                                        color: "#007f00",
                                                      }}
                                                    >{` [PB]`}</strong>
                                                  )}
                                              </Typography>
                                            );
                                          }
                                        )}

                                      {/* Break 2 */}
                                      {Array.isArray(
                                        row.workStartTime.secoundBreak
                                      ) &&
                                        row.workStartTime.secoundBreak.map(
                                          (
                                            time: string | [string, string],
                                            index: number
                                          ) => {
                                            let punchOut: string | undefined;
                                            let punchIn: string | undefined;

                                            // Support both ["out", "in"] or just ["out"]
                                            if (Array.isArray(time)) {
                                              [punchOut, punchIn] = time;
                                            } else {
                                              punchOut = time;
                                              punchIn = undefined;
                                            }

                                            const punchDate = dayjs(
                                              row.workStartTime?.punched_date
                                            );
                                            const breakOut = punchOut
                                              ? dayjs(punchOut)
                                              : null;
                                            const breakIn = punchIn
                                              ? dayjs(punchIn)
                                              : null;

                                            const formatBreak = (
                                              t: Dayjs | null
                                            ) =>
                                              !t || !t.isValid()
                                                ? "Pending"
                                                : (t.isSame(punchDate, "day")
                                                    ? t.format("h:mm a")
                                                    : t.format("MMM D, h:mm a")
                                                  )
                                                    .replace("am", "a.m.")
                                                    .replace("pm", "p.m.");
                                            const isPaidBreak =
                                              parseFloat(
                                                (
                                                  row.workStartTime
                                                    ?.secoundbreakhour ?? "0"
                                                ).toString()
                                              ) > 0;

                                            return (
                                              <Typography
                                                key={`break1-${index}`}
                                                sx={{
                                                  // color:"#007f00",
                                                  fontWeight: 600,
                                                  lineHeight: 1.5,
                                                  fontSize: "0.875rem",
                                                  paddingLeft: "1px",
                                                  // fontStyle: "italic",
                                                  marginTop: 0.5,
                                                }}
                                                color="textSecondary"
                                              >
                                                Break 2: {formatBreak(breakOut)}{" "}
                                                - {formatBreak(breakIn)}
                                                {breakOut &&
                                                  breakIn &&
                                                  isPaidBreak && (
                                                    <strong
                                                      style={{
                                                        color: "#007f00",
                                                      }}
                                                    >{` [PB]`}</strong>
                                                  )}
                                              </Typography>
                                            );
                                          }
                                        )}
                                    </>
                                  )}
                                </>
                              </TableCell>
                              <TableCell
                                scope="row"
                                className={classes.tablCell}
                                // sx={{ textAlign: "center" }}
                              >
                                <Grid
                                  container
                                  spacing={1}
                                  // justifyContent={"center"}
                                >
                                  <Grid
                                    item
                                    lg={12}
                                    md={12}
                                    sm={12}
                                    xs={12}
                                    sx={{
                                      display: "flex",
                                      // justifyContent: "center",
                                    }}
                                  >
                                    <Box
                                      // className={
                                      //   row.isStartWork === false
                                      //     ? classes.editButtonStatusWaiting
                                      //     : classes.editButtonStatusAvailable
                                      // }
                                      sx={{
                                        cursor: row.workStartTime?.punched_time
                                          ? "pointer"
                                          : "pointer",
                                      }}
                                      // onClick={() => {
                                      //   if (
                                      //     row.workStartTime?.punched_time &&
                                      //     userHasRight(Privileges.ScheduleEdit)
                                      //   ) {
                                      //     handleOpenDialogAdminEditPunchIn(
                                      //       row.workStartTime
                                      //     );
                                      //   } else {
                                      //     handleOpenDialogAdminEdit(
                                      //       row,
                                      //       "punch_in"
                                      //     );
                                      //   }
                                      // }}
                                    >
                                      {userHasRight(Privileges.ScheduleEdit) &&
                                      row.workStartTime?.punched_time ? (
                                        <>
                                          <Tooltip
                                            title={
                                              <Box sx={{ p: 1, maxWidth: 300 }}>
                                                {row.workStartTime
                                                  ?.punchInHistory?.length >
                                                  0 && (
                                                  <Typography
                                                    variant="body2"
                                                    sx={{
                                                      fontWeight: 600,
                                                      mb: 1,
                                                    }}
                                                  >
                                                    Punch-in Edit History
                                                  </Typography>
                                                )}

                                                {row.workStartTime
                                                  ?.punchInHistory?.length >
                                                0 ? (
                                                  row.workStartTime.punchInHistory.map(
                                                    (history) => (
                                                      <Box
                                                        key={history.id}
                                                        sx={{
                                                          mb: 1,
                                                          p: 1,
                                                          borderRadius: 1,
                                                          backgroundColor:
                                                            "#f9f9f9",
                                                          border:
                                                            "1px solid #e0e0e0",
                                                        }}
                                                      >
                                                        <Typography
                                                          variant="body2"
                                                          className={
                                                            classes.tooltipTypograpy
                                                          }
                                                        >
                                                          <strong>Date:</strong>{" "}
                                                          {dayjs(
                                                            history.date
                                                          ).format(
                                                            "MMM DD, YYYY"
                                                          )}
                                                        </Typography>
                                                        {history.time && (
                                                          <Typography
                                                            variant="body2"
                                                            className={
                                                              classes.tooltipTypograpy
                                                            }
                                                          >
                                                            <strong>
                                                              Time:
                                                            </strong>{" "}
                                                            {formatTime(
                                                              history.time
                                                            )}
                                                          </Typography>
                                                        )}
                                                        {history.status ===
                                                          "Created" && (
                                                          <Typography
                                                            variant="body2"
                                                            className={
                                                              classes.tooltipTypograpy
                                                            }
                                                          >
                                                            <strong>
                                                              Method:
                                                            </strong>{" "}
                                                            {history.isFacialPunch
                                                              ? "Facial"
                                                              : "Fingerprint"}
                                                          </Typography>
                                                        )}
                                                        {history.status ===
                                                          "AdminCreatedInLocal" && (
                                                          <Typography
                                                            variant="body2"
                                                            className={
                                                              classes.tooltipTypograpy
                                                            }
                                                          >
                                                            <strong>
                                                              Method:
                                                            </strong>{" "}
                                                            {history.isFacialPunch
                                                              ? "Facial Local Admin"
                                                              : "Fingerprint Local Admin"}
                                                          </Typography>
                                                        )}
                                                        {history.reason && (
                                                          <Typography
                                                            variant="body2"
                                                            className={
                                                              classes.tooltipTypograpy
                                                            }
                                                          >
                                                            <strong>
                                                              Reason:
                                                            </strong>{" "}
                                                            {history.reason}
                                                          </Typography>
                                                        )}
                                                        {history.created_by && (
                                                          <Typography
                                                            variant="body2"
                                                            className={
                                                              classes.tooltipTypograpy
                                                            }
                                                          >
                                                            <strong>
                                                              Updated By:
                                                            </strong>{" "}
                                                            {userMap.get(
                                                              history.created_by
                                                            ) || ""}
                                                          </Typography>
                                                        )}
                                                        <Typography
                                                          variant="body2"
                                                          className={
                                                            classes.tooltipTypograpy
                                                          }
                                                        >
                                                          <strong>
                                                            Updated At:
                                                          </strong>{" "}
                                                          {dayjs(
                                                            history.created_at
                                                          ).format(
                                                            "MMM DD, YYYY hh:mm A"
                                                          )}
                                                        </Typography>
                                                        {history.emp_image && (
                                                          <Typography
                                                            variant="body2"
                                                            className={
                                                              classes.tooltipTypograpy
                                                            }
                                                          >
                                                            <strong>
                                                              Image:
                                                            </strong>{" "}
                                                            <a
                                                              href={
                                                                history.emp_image
                                                              }
                                                              target="_blank"
                                                              rel="noopener noreferrer"
                                                              style={{
                                                                color:
                                                                  "#1976d2",
                                                                textDecoration:
                                                                  "underline",
                                                              }}
                                                            >
                                                              View Image
                                                            </a>
                                                          </Typography>
                                                        )}
                                                      </Box>
                                                    )
                                                  )
                                                ) : (
                                                  <Typography
                                                    variant="body2"
                                                    sx={{
                                                      fontWeight: 600,
                                                      mb: 1,
                                                    }}
                                                  >
                                                    Edit Punch-in
                                                  </Typography>
                                                )}
                                              </Box>
                                            }
                                            sx={{ fontSize: "14px" }}
                                          >
                                            <Chip
                                              sx={{
                                                cursor: row.workStartTime
                                                  ?.punched_time
                                                  ? "pointer"
                                                  : "pointer",
                                              }}
                                              className={
                                                row.isStartWork === false
                                                  ? classes.editChipWorkFalse
                                                  : classes.editChipWorkTrue
                                              }
                                              label={
                                                <>
                                                  {formatTime(
                                                    row.workStartTime
                                                      .punched_time
                                                  ) || "Pending"}
                                                  <CiEdit
                                                    style={{
                                                      fontSize: 20,
                                                      marginLeft: "5px",
                                                    }}
                                                  />
                                                </>
                                              }
                                            />
                                          </Tooltip>
                                        </>
                                      ) : (
                                        <Chip
                                          sx={{
                                            cursor: row.workStartTime
                                              ?.punched_time
                                              ? "pointer"
                                              : "pointer",
                                          }}
                                          className={
                                            row.isFinishWork === false
                                              ? classes.editChipWorkFalse
                                              : classes.editChipWorkTrue
                                          }
                                          label={
                                            formatTime(
                                              row.workStartTime?.punched_time
                                            ) || "Pending"
                                          }
                                        />
                                      )}
                                    </Box>
                                  </Grid>
                                  {row.workStartTime?.punched_time &&
                                    row.workStartTime?.created_by && (
                                      <Grid
                                        item
                                        lg={12}
                                        md={12}
                                        sm={12}
                                        xs={12}
                                        sx={{
                                          display: "flex",
                                          // justifyContent: "center",
                                        }}
                                      >
                                        <Typography
                                          sx={{
                                            fontStyle: "italic",
                                          }}
                                          color="textSecondary"
                                          variant="body2"
                                        >
                                          -- Edited --
                                        </Typography>
                                      </Grid>
                                    )}
                                </Grid>
                              </TableCell>

                              <TableCell
                                scope="row"
                                className={classes.tablCell}
                                // sx={{ textAlign: "center" }}
                              >
                                <Grid
                                  container
                                  spacing={1}
                                  // justifyContent={"center"}
                                >
                                  <Grid
                                    item
                                    lg={12}
                                    md={12}
                                    sm={12}
                                    xs={12}
                                    sx={{
                                      display: "flex",
                                      // justifyContent: "center",
                                    }}
                                  >
                                    <Box
                                      // className={
                                      //   row.isFinishWork === false
                                      //     ? classes.editButtonStatusWaiting
                                      //     : classes.editButtonStatusAvailable
                                      // }
                                      sx={{
                                        cursor: row.finishWorkTime?.punched_time
                                          ? "pointer"
                                          : "pointer",
                                      }}
                                      // onClick={() => {
                                      //   if (
                                      //     row.finishWorkTime?.punched_time &&
                                      //     userHasRight(Privileges.ScheduleEdit)
                                      //   ) {
                                      //     handleOpenDialogAdminEditPunchOut(
                                      //       row.finishWorkTime
                                      //     );
                                      //   } else if (
                                      //     row.workStartTime?.punched_time &&
                                      //     userHasRight(Privileges.ScheduleEdit)
                                      //   ) {
                                      //     handleOpenDialogAdminEdit(
                                      //       row,
                                      //       "punch_out"
                                      //     );
                                      //   }
                                      // }}
                                    >
                                      {userHasRight(Privileges.ScheduleEdit) &&
                                      row.finishWorkTime?.punched_time ? (
                                        <Tooltip
                                          title={
                                            <Box sx={{ p: 1, maxWidth: 300 }}>
                                              {row.finishWorkTime
                                                ?.punchOutHistory?.length >
                                                0 && (
                                                <Typography
                                                  variant="body2"
                                                  sx={{
                                                    fontWeight: 600,
                                                    mb: 1,
                                                  }}
                                                >
                                                  Punch-out Edit History
                                                </Typography>
                                              )}

                                              {row.finishWorkTime
                                                ?.punchOutHistory?.length >
                                              0 ? (
                                                row.finishWorkTime.punchOutHistory.map(
                                                  (history) => (
                                                    <Box
                                                      key={history.id}
                                                      sx={{
                                                        mb: 1,
                                                        p: 1,
                                                        borderRadius: 1,
                                                        backgroundColor:
                                                          "#f9f9f9",
                                                        border:
                                                          "1px solid #e0e0e0",
                                                      }}
                                                    >
                                                      <Typography
                                                        variant="body2"
                                                        className={
                                                          classes.tooltipTypograpy
                                                        }
                                                      >
                                                        <strong>Date:</strong>{" "}
                                                        {dayjs(
                                                          history.date
                                                        ).format(
                                                          "MMM DD, YYYY"
                                                        )}
                                                      </Typography>
                                                      {history.time && (
                                                        <Typography
                                                          variant="body2"
                                                          className={
                                                            classes.tooltipTypograpy
                                                          }
                                                        >
                                                          <strong>Time:</strong>{" "}
                                                          {formatTime(
                                                            history.time
                                                          )}
                                                        </Typography>
                                                      )}
                                                      {history.status ===
                                                        "Created" && (
                                                        <Typography
                                                          variant="body2"
                                                          className={
                                                            classes.tooltipTypograpy
                                                          }
                                                        >
                                                          <strong>
                                                            Method:
                                                          </strong>{" "}
                                                          {history.isFacialPunch
                                                            ? "Facial"
                                                            : "Fingerprint"}
                                                        </Typography>
                                                      )}
                                                      {history.status ===
                                                        "AdminCreatedInLocal" && (
                                                        <Typography
                                                          variant="body2"
                                                          className={
                                                            classes.tooltipTypograpy
                                                          }
                                                        >
                                                          <strong>
                                                            Method:
                                                          </strong>{" "}
                                                          {history.isFacialPunch
                                                            ? "Facial Local Admin"
                                                            : "Fingerprint Local Admin"}
                                                        </Typography>
                                                      )}
                                                      {history.reason && (
                                                        <Typography
                                                          variant="body2"
                                                          className={
                                                            classes.tooltipTypograpy
                                                          }
                                                        >
                                                          <strong>
                                                            Reason:
                                                          </strong>{" "}
                                                          {history.reason}
                                                        </Typography>
                                                      )}
                                                      {history.created_by && (
                                                        <Typography
                                                          variant="body2"
                                                          className={
                                                            classes.tooltipTypograpy
                                                          }
                                                        >
                                                          <strong>
                                                            Updated By:
                                                          </strong>{" "}
                                                          {userMap.get(
                                                            history.created_by
                                                          ) || ""}
                                                        </Typography>
                                                      )}
                                                      <Typography
                                                        variant="body2"
                                                        className={
                                                          classes.tooltipTypograpy
                                                        }
                                                      >
                                                        <strong>
                                                          Updated At:
                                                        </strong>{" "}
                                                        {dayjs(
                                                          history.created_at
                                                        ).format(
                                                          "MMM DD, YYYY hh:mm A"
                                                        )}
                                                      </Typography>
                                                      {history.emp_image && (
                                                        <Typography
                                                          variant="body2"
                                                          className={
                                                            classes.tooltipTypograpy
                                                          }
                                                        >
                                                          <strong>
                                                            Image:
                                                          </strong>{" "}
                                                          <a
                                                            href={
                                                              history.emp_image
                                                            }
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            style={{
                                                              color: "#1976d2",
                                                              textDecoration:
                                                                "underline",
                                                            }}
                                                          >
                                                            View Image
                                                          </a>
                                                        </Typography>
                                                      )}
                                                    </Box>
                                                  )
                                                )
                                              ) : (
                                                <Typography
                                                  variant="body2"
                                                  sx={{
                                                    fontWeight: 600,
                                                    mb: 1,
                                                  }}
                                                >
                                                  Edit Punch-out
                                                </Typography>
                                              )}
                                            </Box>
                                          }
                                          sx={{ fontSize: "14px" }}
                                        >
                                          <Chip
                                            sx={{
                                              cursor: row.finishWorkTime
                                                ?.punched_time
                                                ? "pointer"
                                                : "pointer",
                                            }}
                                            className={
                                              row.isFinishWork === false
                                                ? classes.editChipWorkFalse
                                                : classes.editChipWorkTrue
                                            }
                                            label={
                                              <>
                                                {row.workStartTime
                                                  ?.punched_date !==
                                                row.finishWorkTime.punched_date
                                                  ? `${dayjs(
                                                      row.finishWorkTime
                                                        .punched_date
                                                    ).format(
                                                      "MMM-DD, YYYY"
                                                    )} ${formatTime(
                                                      row.finishWorkTime
                                                        .punched_time
                                                    )}`
                                                  : formatTime(
                                                      row.finishWorkTime
                                                        .punched_time
                                                    ) || "Pending"}
                                                <CiEdit
                                                  style={{
                                                    fontSize: 20,
                                                    marginLeft: "5px",
                                                  }}
                                                />
                                              </>
                                            }
                                          />
                                        </Tooltip>
                                      ) : (
                                        <Chip
                                          sx={{
                                            cursor:
                                              row.finishWorkTime
                                                ?.punched_time ||
                                              row.workStartTime?.punched_time
                                                ? "pointer"
                                                : "default",
                                          }}
                                          className={
                                            row.isFinishWork === false
                                              ? classes.editChipWorkFalse
                                              : classes.editChipWorkTrue
                                          }
                                          label={
                                            formatTime(
                                              row.finishWorkTime?.punched_time
                                            ) || "Pending"
                                          }
                                        />
                                      )}
                                    </Box>
                                  </Grid>
                                  {row.finishWorkTime?.punched_time &&
                                    row.finishWorkTime?.updated_by && (
                                      <Grid
                                        item
                                        lg={12}
                                        md={12}
                                        sm={12}
                                        xs={12}
                                        sx={{
                                          display: "flex",
                                          // justifyContent: "center",
                                        }}
                                      >
                                        <Typography
                                          sx={{
                                            fontStyle: "italic",
                                          }}
                                          color="textSecondary"
                                          variant="body2"
                                        >
                                          -- Edited --
                                        </Typography>
                                      </Grid>
                                    )}
                                </Grid>
                              </TableCell>

                              <TableCell className={classes.tablCell}>
                                <Grid
                                  container
                                  spacing={1}
                                  alignItems="center"
                                  justifyContent="flex-end"
                                >
                                  <Grid item>
                                    <Typography
                                      sx={{
                                        // color: "#d32f2f",
                                        fontWeight: 600,
                                        lineHeight: 1.5,
                                        fontSize: "0.875rem",
                                        fontStyle: "italic",
                                        whiteSpace: "nowrap",
                                        // textAlign: "end"
                                      }}
                                    >
                                      {row.deletepunchNote?.reason}
                                    </Typography>
                                    <Typography
                                      sx={{
                                        fontStyle: "italic",
                                        textAlign: "end",
                                      }}
                                      color="textSecondary"
                                      variant="body2"
                                    >
                                      Deleted By -{" "}
                                      {userMap.get(
                                        row.deletepunchNote?.created_by
                                      ) || ""}
                                    </Typography>
                                    <Typography
                                      sx={{
                                        fontStyle: "italic",
                                        textAlign: "end",
                                      }}
                                      color="textSecondary"
                                      variant="body2"
                                    >
                                      Deleted At -
                                      {dayjs(
                                        row.deletepunchNote?.created_at
                                      ).format("MMM DD, YYYY hh:mm A")}
                                    </Typography>
                                  </Grid>
                                </Grid>
                              </TableCell>
                            </TableRow>
                          )
                        )
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Grid>
            </Card>
          </Grid>
        ) : (
          deleteRecords.length > 0 &&
          !deleteRecordIsError && (
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <Card className={classes.card}>
                <Grid
                  container
                  justifyContent={"space-between"}
                  spacing={5}
                  sx={{ borderBottom: 2, padding: 2 }}
                  className={classes.titleGrid}
                >
                  <Grid
                    item
                    lg={12}
                    md={12}
                    sm={12}
                    xs={12}
                    sx={{ display: "flex", justifyContent: "flex-start" }}
                  >
                    <Grid
                      container
                      spacing={1}
                      justifyContent="flex-start"
                      sx={{
                        display: "flex",
                        justifyContent: {
                          xs: "flex-start",
                          md: "flex-start",
                        },
                      }}
                    >
                      <Grid item>
                        <Grid item>
                          <Typography
                            sx={{
                              color: "#d32f2f",
                              fontWeight: 600,
                              lineHeight: 1.5,
                              fontSize: "16px",
                              // fontStyle: "italic",
                              whiteSpace: "nowrap",
                            }}
                          >
                            Deleted Records
                          </Typography>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>

                <Grid>
                  <TableContainer>
                    <Table className={classes.table}>
                      <TableHead className={classes.tableHeaderRow}>
                        <TableRow>
                          <TableCell className={classes.tablheader}>
                            <strong>Name</strong>
                          </TableCell>
                          <TableCell
                            className={classes.tablheader}
                            // sx={{ textAlign: "center" }}
                          >
                            <strong>Schedule</strong>
                          </TableCell>
                          <TableCell
                            className={classes.tablheader}
                            // sx={{ textAlign: "center" }}
                          >
                            <strong>clocked Hours</strong>
                          </TableCell>
                          <TableCell
                            className={classes.tablheader}
                            // sx={{ textAlign: "center" }}
                          >
                            <strong>Punch In</strong>
                          </TableCell>
                          <TableCell
                            className={classes.tablheader}
                            // sx={{ textAlign: "center" }}
                          >
                            <strong>Punch Out</strong>
                          </TableCell>
                          <TableCell
                            className={classes.tablheader}
                            sx={{ textAlign: "right" }}
                          >
                            <strong>Reason</strong>
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {deleteRecordIsLoadig || tenantIsLoading ? (
                          <TableRow>
                            <TableCell colSpan={20} align="center">
                              <Box display="flex" justifyContent="center" alignItems="center" height="10vh">
                      <StepUpSpinner size="medium" />
                    </Box>
                            </TableCell>
                          </TableRow>
                        ) : deleteRecordIsError ||
                          deleteRecords.length === 0 ? (
                          <TableRow>
                            <TableCell colSpan={20} align="center">
                              {deleteRecordIsError
                                ? "Error fetching data"
                                : "No data available"}
                            </TableCell>
                          </TableRow>
                        ) : (
                          deleteRecords.map(
                            (row: IScheduleListDetails, index) => (
                              <>
                                <TableRow
                                  key={index}
                                  className={classes.tableRowHover}
                                  // sx={{
                                  //   backgroundColor:
                                  //     !row.workStartTime?.punched_time &&
                                  //     row.schedule?.startTime &&
                                  //     dayjs(
                                  //       `2000-01-01T${row.schedule?.startTime}`
                                  //     ).isBefore(
                                  //       dayjs(`2000-01-01T${dayjs().format("HH:mm")}`)
                                  //     )
                                  //       ? "#f5e5e5c4"
                                  //       : "transparent",
                                  // }}
                                >
                                  <TableCell
                                    component="th"
                                    scope="row"
                                    className={classes.tablCell}
                                  >
                                    {" "}
                                    <Grid container spacing={1}>
                                      {/* <Grid item>
                                  <Box className={classes.SelectImageTableBox}>
                                    {teamMap.get(row.empid)?.image ? (
                                      <img
                                        src={teamMap.get(row.empid)?.image}
                                        alt="Category Image"
                                        className={classes.SelectImageTable}
                                      />
                                    ) : (
                                      <Avatar
                                        alt="Travis Howard"
                                        src={AvatarImg}
                                        className={classes.SelectImageTable}
                                      />
                                    )}
                                  </Box>
                                </Grid> */}
                                      <Grid item>
                                        <Link
                                          to={`/team-history/${row.empid}`}
                                          className={classes.iconLinkPropNormal}
                                        >
                                          <Typography
                                            className={classes.nameTableList}
                                          >
                                            {teamMap.get(row.empid)?.name || ""}
                                            {/* <span
                                          style={{
                                            cursor: "pointer",
                                            display: "inline-flex",
                                            alignItems: "center",
                                            paddingLeft: "5px",
                                          }}
                                        >
                                          <FontAwesomeIcon
                                            icon={faUser}
                                            style={{ color: "#1976d2" }}
                                          />
                                        </span> */}
                                          </Typography>
                                        </Link>
                                      </Grid>
                                    </Grid>
                                  </TableCell>
                                  <TableCell
                                    scope="row"
                                    className={classes.tablCell}
                                    // sx={{ textAlign: "center" }}
                                  >
                                    {formatTime(row.schedule?.startTime)} -{" "}
                                    {formatTime(row.schedule?.endTime)}{" "}
                                    {row.schedule &&
                                      row.schedule.spansNextDay == true && (
                                        <span
                                          style={{
                                            color: "#e3791a",
                                            fontWeight: 600,
                                            lineHeight: 1.5,
                                            fontSize: "0.875rem",
                                            paddingLeft: "1px",
                                          }}
                                        >
                                          [next day]
                                        </span>
                                      )}
                                    {row.schedule &&
                                    row.schedule.schedule_end_date ? (
                                      row.schedule.status === "deleted" ? (
                                        <span
                                          style={{
                                            color: "#d32f2f", // red
                                            fontWeight: 600,
                                            paddingLeft: "1px",
                                          }}
                                        >
                                          [D]
                                        </span>
                                      ) : row.schedule.schedule_end_date &&
                                        row.schedule.status === "updated" ? (
                                        <span
                                          style={{
                                            color: "#1976d2", // blue
                                            fontWeight: 600,
                                            paddingLeft: "1px",
                                          }}
                                        >
                                          [Up]
                                        </span>
                                      ) : null
                                    ) : null}
                                    {row.schedule &&
                                      row.schedule.total_scheduled_hours && (
                                        <span
                                          style={{
                                            color: "#28a745",
                                            fontWeight: 600,
                                            lineHeight: 1.5,
                                            fontSize: "0.875rem",
                                            paddingLeft: "1px",
                                          }}
                                        >
                                          {`(${row.schedule.total_scheduled_hours}h)`}
                                        </span>
                                      )}
                                  </TableCell>
                                  <TableCell
                                    scope="row"
                                    className={classes.tablCell}
                                    // sx={{ textAlign: "center" }}
                                  >
                                    <>
                                      {row.workStartTime
                                        ?.actual_punched_time ? (
                                        <>
                                          {formatTime(
                                            row.workStartTime
                                              .actual_punched_time
                                          )}{" "}
                                          -{" "}
                                          {row.finishWorkTime
                                            ?.actual_punched_time
                                            ? formatTime(
                                                row.finishWorkTime
                                                  .actual_punched_time
                                              )
                                            : "Pending"}
                                        </>
                                      ) : (
                                        ""
                                      )}
                                      <br />
                                      {row.workStartTime && (
                                        <>
                                          {Array.isArray(
                                            row.workStartTime.fristBreak
                                          ) &&
                                            row.workStartTime.fristBreak.map(
                                              (
                                                time: string | [string, string],
                                                index: number
                                              ) => {
                                                let punchOut:
                                                  | string
                                                  | undefined;
                                                let punchIn: string | undefined;

                                                // Support both ["out", "in"] or just ["out"]
                                                if (Array.isArray(time)) {
                                                  [punchOut, punchIn] = time;
                                                } else {
                                                  punchOut = time;
                                                  punchIn = undefined;
                                                }

                                                const punchDate = dayjs(
                                                  row.workStartTime
                                                    ?.punched_date
                                                );
                                                const breakOut = punchOut
                                                  ? dayjs(punchOut)
                                                  : null;
                                                const breakIn = punchIn
                                                  ? dayjs(punchIn)
                                                  : null;

                                                const formatBreak = (
                                                  t: Dayjs | null
                                                ) =>
                                                  !t || !t.isValid()
                                                    ? "Pending"
                                                    : (t.isSame(
                                                        punchDate,
                                                        "day"
                                                      )
                                                        ? t.format("h:mm a")
                                                        : t.format(
                                                            "MMM D, h:mm a"
                                                          )
                                                      )
                                                        .replace("am", "a.m.")
                                                        .replace("pm", "p.m.");
                                                const isPaidBreak =
                                                  parseFloat(
                                                    (
                                                      row.workStartTime
                                                        ?.fristbreakhour ?? "0"
                                                    ).toString()
                                                  ) > 0;

                                                return (
                                                  <Typography
                                                    key={`break1-${index}`}
                                                    sx={{
                                                      // color:"#007f00",
                                                      fontWeight: 600,
                                                      lineHeight: 1.5,
                                                      fontSize: "0.875rem",
                                                      paddingLeft: "1px",
                                                      // fontStyle: "italic",
                                                      marginTop: 0.5,
                                                    }}
                                                    color="textSecondary"
                                                  >
                                                    Break 1:{" "}
                                                    {formatBreak(breakOut)} -{" "}
                                                    {formatBreak(breakIn)}
                                                    {breakOut &&
                                                      breakIn &&
                                                      isPaidBreak && (
                                                        <strong
                                                          style={{
                                                            color: "#007f00",
                                                          }}
                                                        >{` [PB]`}</strong>
                                                      )}
                                                  </Typography>
                                                );
                                              }
                                            )}

                                          {/* Break 2 */}
                                          {Array.isArray(
                                            row.workStartTime.secoundBreak
                                          ) &&
                                            row.workStartTime.secoundBreak.map(
                                              (
                                                time: string | [string, string],
                                                index: number
                                              ) => {
                                                let punchOut:
                                                  | string
                                                  | undefined;
                                                let punchIn: string | undefined;

                                                // Support both ["out", "in"] or just ["out"]
                                                if (Array.isArray(time)) {
                                                  [punchOut, punchIn] = time;
                                                } else {
                                                  punchOut = time;
                                                  punchIn = undefined;
                                                }

                                                const punchDate = dayjs(
                                                  row.workStartTime
                                                    ?.punched_date
                                                );
                                                const breakOut = punchOut
                                                  ? dayjs(punchOut)
                                                  : null;
                                                const breakIn = punchIn
                                                  ? dayjs(punchIn)
                                                  : null;

                                                const formatBreak = (
                                                  t: Dayjs | null
                                                ) =>
                                                  !t || !t.isValid()
                                                    ? "Pending"
                                                    : (t.isSame(
                                                        punchDate,
                                                        "day"
                                                      )
                                                        ? t.format("h:mm a")
                                                        : t.format(
                                                            "MMM D, h:mm a"
                                                          )
                                                      )
                                                        .replace("am", "a.m.")
                                                        .replace("pm", "p.m.");
                                                const isPaidBreak =
                                                  parseFloat(
                                                    (
                                                      row.workStartTime
                                                        ?.secoundbreakhour ??
                                                      "0"
                                                    ).toString()
                                                  ) > 0;

                                                return (
                                                  <Typography
                                                    key={`break1-${index}`}
                                                    sx={{
                                                      // color:"#007f00",
                                                      fontWeight: 600,
                                                      lineHeight: 1.5,
                                                      fontSize: "0.875rem",
                                                      paddingLeft: "1px",
                                                      // fontStyle: "italic",
                                                      marginTop: 0.5,
                                                    }}
                                                    color="textSecondary"
                                                  >
                                                    Break 2:{" "}
                                                    {formatBreak(breakOut)} -{" "}
                                                    {formatBreak(breakIn)}
                                                    {breakOut &&
                                                      breakIn &&
                                                      isPaidBreak && (
                                                        <strong
                                                          style={{
                                                            color: "#007f00",
                                                          }}
                                                        >{` [PB]`}</strong>
                                                      )}
                                                  </Typography>
                                                );
                                              }
                                            )}
                                        </>
                                      )}
                                    </>
                                  </TableCell>
                                  <TableCell
                                    scope="row"
                                    className={classes.tablCell}
                                    // sx={{ textAlign: "center" }}
                                  >
                                    <Grid
                                      container
                                      spacing={1}
                                      // justifyContent={"center"}
                                    >
                                      <Grid
                                        item
                                        lg={12}
                                        md={12}
                                        sm={12}
                                        xs={12}
                                        sx={{
                                          display: "flex",
                                          // justifyContent: "center",
                                        }}
                                      >
                                        <Box
                                          // className={
                                          //   row.isStartWork === false
                                          //     ? classes.editButtonStatusWaiting
                                          //     : classes.editButtonStatusAvailable
                                          // }
                                          sx={{
                                            cursor: row.workStartTime
                                              ?.punched_time
                                              ? "pointer"
                                              : "pointer",
                                          }}
                                          // onClick={() => {
                                          //   if (
                                          //     row.workStartTime?.punched_time &&
                                          //     userHasRight(
                                          //       Privileges.ScheduleEdit
                                          //     )
                                          //   ) {
                                          //     handleOpenDialogAdminEditPunchIn(
                                          //       row.workStartTime
                                          //     );
                                          //   } else {
                                          //     handleOpenDialogAdminEdit(
                                          //       row,
                                          //       "punch_in"
                                          //     );
                                          //   }
                                          // }}
                                        >
                                          {userHasRight(
                                            Privileges.ScheduleEdit
                                          ) &&
                                          row.workStartTime?.punched_time ? (
                                            <>
                                              <Tooltip
                                                title={
                                                  <Box
                                                    sx={{ p: 1, maxWidth: 300 }}
                                                  >
                                                    {row.workStartTime
                                                      ?.punchInHistory?.length >
                                                      0 && (
                                                      <Typography
                                                        variant="body2"
                                                        sx={{
                                                          fontWeight: 600,
                                                          mb: 1,
                                                        }}
                                                      >
                                                        Punch-in Edit History
                                                      </Typography>
                                                    )}

                                                    {row.workStartTime
                                                      ?.punchInHistory?.length >
                                                    0 ? (
                                                      row.workStartTime.punchInHistory.map(
                                                        (history) => (
                                                          <Box
                                                            key={history.id}
                                                            sx={{
                                                              mb: 1,
                                                              p: 1,
                                                              borderRadius: 1,
                                                              backgroundColor:
                                                                "#f9f9f9",
                                                              border:
                                                                "1px solid #e0e0e0",
                                                            }}
                                                          >
                                                            <Typography
                                                              variant="body2"
                                                              className={
                                                                classes.tooltipTypograpy
                                                              }
                                                            >
                                                              <strong>
                                                                Date:
                                                              </strong>{" "}
                                                              {dayjs(
                                                                history.date
                                                              ).format(
                                                                "MMM DD, YYYY"
                                                              )}
                                                            </Typography>
                                                            {history.time && (
                                                              <Typography
                                                                variant="body2"
                                                                className={
                                                                  classes.tooltipTypograpy
                                                                }
                                                              >
                                                                <strong>
                                                                  Time:
                                                                </strong>{" "}
                                                                {/* {dayjs(
                                                                history.time,
                                                                "HH:mm:ss"
                                                              ).format(
                                                                "hh:mm A"
                                                              )} */}
                                                                {formatTime(
                                                                  history.time
                                                                )}
                                                              </Typography>
                                                            )}
                                                            {history.status ===
                                                              "Created" && (
                                                              <Typography
                                                                variant="body2"
                                                                className={
                                                                  classes.tooltipTypograpy
                                                                }
                                                              >
                                                                <strong>
                                                                  Method:
                                                                </strong>{" "}
                                                                {history.isFacialPunch
                                                                  ? "Facial"
                                                                  : "Fingerprint"}
                                                              </Typography>
                                                            )}
                                                            {history.status ===
                                                              "AdminCreatedInLocal" && (
                                                              <Typography
                                                                variant="body2"
                                                                className={
                                                                  classes.tooltipTypograpy
                                                                }
                                                              >
                                                                <strong>
                                                                  Method:
                                                                </strong>{" "}
                                                                {history.isFacialPunch
                                                                  ? "Facial Local Admin"
                                                                  : "Fingerprint Local Admin"}
                                                              </Typography>
                                                            )}
                                                            {history.reason && (
                                                              <Typography
                                                                variant="body2"
                                                                className={
                                                                  classes.tooltipTypograpy
                                                                }
                                                              >
                                                                <strong>
                                                                  Reason:
                                                                </strong>{" "}
                                                                {history.reason}
                                                              </Typography>
                                                            )}
                                                            {history.created_by && (
                                                              <Typography
                                                                variant="body2"
                                                                className={
                                                                  classes.tooltipTypograpy
                                                                }
                                                              >
                                                                <strong>
                                                                  Updated By:
                                                                </strong>{" "}
                                                                {userMap.get(
                                                                  history.created_by
                                                                ) || ""}
                                                              </Typography>
                                                            )}
                                                            <Typography
                                                              variant="body2"
                                                              className={
                                                                classes.tooltipTypograpy
                                                              }
                                                            >
                                                              <strong>
                                                                Updated At:
                                                              </strong>{" "}
                                                              {dayjs(
                                                                history.created_at
                                                              ).format(
                                                                "MMM DD, YYYY hh:mm A"
                                                              )}
                                                            </Typography>
                                                            {history.emp_image && (
                                                              <Typography
                                                                variant="body2"
                                                                className={
                                                                  classes.tooltipTypograpy
                                                                }
                                                              >
                                                                <strong>
                                                                  Image:
                                                                </strong>{" "}
                                                                <a
                                                                  href={
                                                                    history.emp_image
                                                                  }
                                                                  target="_blank"
                                                                  rel="noopener noreferrer"
                                                                  style={{
                                                                    color:
                                                                      "#1976d2",
                                                                    textDecoration:
                                                                      "underline",
                                                                  }}
                                                                >
                                                                  View Image
                                                                </a>
                                                              </Typography>
                                                            )}
                                                          </Box>
                                                        )
                                                      )
                                                    ) : (
                                                      <Typography
                                                        variant="body2"
                                                        sx={{
                                                          fontWeight: 600,
                                                          mb: 1,
                                                        }}
                                                      >
                                                        Edit Punch-in
                                                      </Typography>
                                                    )}
                                                  </Box>
                                                }
                                                sx={{ fontSize: "14px" }}
                                              >
                                                <Chip
                                                  sx={{
                                                    cursor: row.workStartTime
                                                      ?.punched_time
                                                      ? "pointer"
                                                      : "pointer",
                                                  }}
                                                  className={
                                                    row.isStartWork === false
                                                      ? classes.editChipWorkFalse
                                                      : classes.editChipWorkTrue
                                                  }
                                                  label={
                                                    <>
                                                      {formatTime(
                                                        row.workStartTime
                                                          .punched_time
                                                      ) || "Pending"}
                                                      <CiEdit
                                                        style={{
                                                          fontSize: 20,
                                                          marginLeft: "5px",
                                                        }}
                                                      />
                                                    </>
                                                  }
                                                />
                                              </Tooltip>
                                            </>
                                          ) : (
                                            <Chip
                                              sx={{
                                                cursor: row.workStartTime
                                                  ?.punched_time
                                                  ? "pointer"
                                                  : "pointer",
                                              }}
                                              className={
                                                row.isFinishWork === false
                                                  ? classes.editChipWorkFalse
                                                  : classes.editChipWorkTrue
                                              }
                                              label={
                                                formatTime(
                                                  row.workStartTime
                                                    ?.punched_time
                                                ) || "Pending"
                                              }
                                            />
                                          )}
                                        </Box>
                                      </Grid>
                                      {row.workStartTime?.punched_time &&
                                        row.workStartTime?.created_by && (
                                          <Grid
                                            item
                                            lg={12}
                                            md={12}
                                            sm={12}
                                            xs={12}
                                            // sx={{
                                            //   display: "flex",
                                            //   justifyContent: "center",
                                            // }}
                                          >
                                            <Typography
                                              sx={{
                                                fontStyle: "italic",
                                              }}
                                              color="textSecondary"
                                              variant="body2"
                                            >
                                              -- Edited --
                                            </Typography>
                                          </Grid>
                                        )}
                                    </Grid>
                                  </TableCell>
                                  <TableCell
                                    scope="row"
                                    className={classes.tablCell}
                                    // sx={{ textAlign: "center" }}
                                  >
                                    <Grid
                                      container
                                      spacing={1}
                                      // justifyContent={"center"}
                                    >
                                      <Grid
                                        item
                                        lg={12}
                                        md={12}
                                        sm={12}
                                        xs={12}
                                        sx={{
                                          display: "flex",
                                          // justifyContent: "center",
                                        }}
                                      >
                                        <Box
                                          // className={
                                          //   row.isFinishWork === false
                                          //     ? classes.editButtonStatusWaiting
                                          //     : classes.editButtonStatusAvailable
                                          // }
                                          sx={{
                                            cursor: row.finishWorkTime
                                              ?.punched_time
                                              ? "pointer"
                                              : "pointer",
                                          }}
                                          // onClick={() => {
                                          //   if (
                                          //     row.finishWorkTime
                                          //       ?.punched_time &&
                                          //     userHasRight(
                                          //       Privileges.ScheduleEdit
                                          //     )
                                          //   ) {
                                          //     handleOpenDialogAdminEditPunchOut(
                                          //       row.finishWorkTime
                                          //     );
                                          //   } else if (
                                          //     row.workStartTime?.punched_time &&
                                          //     userHasRight(
                                          //       Privileges.ScheduleEdit
                                          //     )
                                          //   ) {
                                          //     handleOpenDialogAdminEdit(
                                          //       row,
                                          //       "punch_out"
                                          //     );
                                          //   }
                                          // }}
                                        >
                                          {userHasRight(
                                            Privileges.ScheduleEdit
                                          ) &&
                                          row.finishWorkTime?.punched_time ? (
                                            <Tooltip
                                              title={
                                                <Box
                                                  sx={{ p: 1, maxWidth: 300 }}
                                                >
                                                  {row.finishWorkTime
                                                    ?.punchOutHistory?.length >
                                                    0 && (
                                                    <Typography
                                                      variant="body2"
                                                      sx={{
                                                        fontWeight: 600,
                                                        mb: 1,
                                                      }}
                                                    >
                                                      Punch-out Edit History
                                                    </Typography>
                                                  )}

                                                  {row.finishWorkTime
                                                    ?.punchOutHistory?.length >
                                                  0 ? (
                                                    row.finishWorkTime.punchOutHistory.map(
                                                      (history) => (
                                                        <Box
                                                          key={history.id}
                                                          sx={{
                                                            mb: 1,
                                                            p: 1,
                                                            borderRadius: 1,
                                                            backgroundColor:
                                                              "#f9f9f9",
                                                            border:
                                                              "1px solid #e0e0e0",
                                                          }}
                                                        >
                                                          <Typography
                                                            variant="body2"
                                                            className={
                                                              classes.tooltipTypograpy
                                                            }
                                                          >
                                                            <strong>
                                                              Date:
                                                            </strong>{" "}
                                                            {dayjs(
                                                              history.date
                                                            ).format(
                                                              "MMM DD, YYYY"
                                                            )}
                                                          </Typography>
                                                          {history.time && (
                                                            <Typography
                                                              variant="body2"
                                                              className={
                                                                classes.tooltipTypograpy
                                                              }
                                                            >
                                                              <strong>
                                                                Time:
                                                              </strong>{" "}
                                                              {formatTime(
                                                                history.time
                                                              )}
                                                            </Typography>
                                                          )}
                                                          {history.status ===
                                                            "Created" && (
                                                            <Typography
                                                              variant="body2"
                                                              className={
                                                                classes.tooltipTypograpy
                                                              }
                                                            >
                                                              <strong>
                                                                Method:
                                                              </strong>{" "}
                                                              {history.isFacialPunch
                                                                ? "Facial"
                                                                : "Fingerprint"}
                                                            </Typography>
                                                          )}
                                                          {history.status ===
                                                            "AdminCreatedInLocal" && (
                                                            <Typography
                                                              variant="body2"
                                                              className={
                                                                classes.tooltipTypograpy
                                                              }
                                                            >
                                                              <strong>
                                                                Method:
                                                              </strong>{" "}
                                                              {history.isFacialPunch
                                                                ? "Facial Local Admin"
                                                                : "Fingerprint Local Admin"}
                                                            </Typography>
                                                          )}
                                                          {history.reason && (
                                                            <Typography
                                                              variant="body2"
                                                              className={
                                                                classes.tooltipTypograpy
                                                              }
                                                            >
                                                              <strong>
                                                                Reason:
                                                              </strong>{" "}
                                                              {history.reason}
                                                            </Typography>
                                                          )}
                                                          {history.created_by && (
                                                            <Typography
                                                              variant="body2"
                                                              className={
                                                                classes.tooltipTypograpy
                                                              }
                                                            >
                                                              <strong>
                                                                Updated By:
                                                              </strong>{" "}
                                                              {userMap.get(
                                                                history.created_by
                                                              ) || ""}
                                                            </Typography>
                                                          )}
                                                          <Typography
                                                            variant="body2"
                                                            className={
                                                              classes.tooltipTypograpy
                                                            }
                                                          >
                                                            <strong>
                                                              Updated At:
                                                            </strong>{" "}
                                                            {dayjs(
                                                              history.created_at
                                                            ).format(
                                                              "MMM DD, YYYY hh:mm A"
                                                            )}
                                                          </Typography>
                                                          {history.emp_image && (
                                                            <Typography
                                                              variant="body2"
                                                              className={
                                                                classes.tooltipTypograpy
                                                              }
                                                            >
                                                              <strong>
                                                                Image:
                                                              </strong>{" "}
                                                              <a
                                                                href={
                                                                  history.emp_image
                                                                }
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                                style={{
                                                                  color:
                                                                    "#1976d2",
                                                                  textDecoration:
                                                                    "underline",
                                                                }}
                                                              >
                                                                View Image
                                                              </a>
                                                            </Typography>
                                                          )}
                                                        </Box>
                                                      )
                                                    )
                                                  ) : (
                                                    <Typography
                                                      variant="body2"
                                                      sx={{
                                                        fontWeight: 600,
                                                        mb: 1,
                                                      }}
                                                    >
                                                      Edit Punch-out
                                                    </Typography>
                                                  )}
                                                </Box>
                                              }
                                              sx={{ fontSize: "14px" }}
                                            >
                                              <Chip
                                                sx={{
                                                  cursor: row.finishWorkTime
                                                    ?.punched_time
                                                    ? "pointer"
                                                    : "pointer",
                                                }}
                                                className={
                                                  row.isFinishWork === false
                                                    ? classes.editChipWorkFalse
                                                    : classes.editChipWorkTrue
                                                }
                                                label={
                                                  <>
                                                    {row.workStartTime
                                                      ?.punched_date !==
                                                    row.finishWorkTime
                                                      .punched_date
                                                      ? `${dayjs(
                                                          row.finishWorkTime
                                                            .punched_date
                                                        ).format(
                                                          "MMM-DD, YYYY"
                                                        )} ${formatTime(
                                                          row.finishWorkTime
                                                            .punched_time
                                                        )}`
                                                      : formatTime(
                                                          row.finishWorkTime
                                                            .punched_time
                                                        ) || "Pending"}
                                                    <CiEdit
                                                      style={{
                                                        fontSize: 20,
                                                        marginLeft: "5px",
                                                      }}
                                                    />
                                                  </>
                                                }
                                              />
                                            </Tooltip>
                                          ) : (
                                            <Chip
                                              sx={{
                                                cursor:
                                                  row.finishWorkTime
                                                    ?.punched_time ||
                                                  row.workStartTime
                                                    ?.punched_time
                                                    ? "pointer"
                                                    : "default",
                                              }}
                                              className={
                                                row.isFinishWork === false
                                                  ? classes.editChipWorkFalse
                                                  : classes.editChipWorkTrue
                                              }
                                              label={
                                                formatTime(
                                                  row.finishWorkTime
                                                    ?.punched_time
                                                ) || "Pending"
                                              }
                                            />
                                          )}
                                        </Box>
                                      </Grid>
                                      {row.finishWorkTime?.punched_time &&
                                        row.finishWorkTime?.updated_by && (
                                          <Grid
                                            item
                                            lg={12}
                                            md={12}
                                            sm={12}
                                            xs={12}
                                            // sx={{
                                            //   display: "flex",
                                            //   justifyContent: "center",
                                            // }}
                                          >
                                            <Typography
                                              sx={{
                                                fontStyle: "italic",
                                              }}
                                              color="textSecondary"
                                              variant="body2"
                                            >
                                              -- Edited --
                                            </Typography>
                                          </Grid>
                                        )}
                                    </Grid>
                                  </TableCell>
                                  <TableCell className={classes.tablCell}>
                                    <Grid
                                      container
                                      spacing={1}
                                      alignItems="center"
                                      justifyContent="flex-end"
                                    >
                                      <Grid item>
                                        <Typography
                                          sx={{
                                            // color: "#d32f2f",
                                            fontWeight: 600,
                                            lineHeight: 1.5,
                                            fontSize: "0.875rem",
                                            fontStyle: "italic",
                                            whiteSpace: "nowrap",
                                            // textAlign: "end"
                                          }}
                                        >
                                          {row.deletepunchNote?.reason}
                                        </Typography>
                                        <Typography
                                          sx={{
                                            fontStyle: "italic",
                                            textAlign: "end",
                                          }}
                                          color="textSecondary"
                                          variant="body2"
                                        >
                                          Deleted By -{" "}
                                          {userMap.get(
                                            row.deletepunchNote?.created_by
                                          ) || ""}
                                        </Typography>
                                        <Typography
                                          sx={{
                                            fontStyle: "italic",
                                            textAlign: "end",
                                          }}
                                          color="textSecondary"
                                          variant="body2"
                                        >
                                          Deleted At -
                                          {dayjs(
                                            row.deletepunchNote?.created_at
                                          ).format("MMM DD, YYYY hh:mm A")}
                                        </Typography>
                                      </Grid>
                                    </Grid>
                                  </TableCell>
                                </TableRow>
                              </>
                            )
                          )
                        )}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Grid>
              </Card>
            </Grid>
          )
        )}
      </>
    </Grid>
  );
};

export default Index;
